/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * jelled services
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from 'react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from 'react-query'
import type {
  LoginResponse,
  AuthImpersonate,
  OrganizationFull,
  Failure,
  AdminOrganizationNew,
  AdminOrganizationUpdate,
  AdminUpdateOrgParams,
  AdminOrganizationDelete,
  AdminDeleteOrgParams,
  Picture,
  NotFoundResponse,
  SearchResultsOrgs,
  NotModifiedResponse,
  ValidationFailedResponse,
  AdminSearchOrgsParams,
  WaitlistEntry,
  WaitlistEntryNew,
  AdminRemoveWaitlistParams,
  AdminUserDelete,
  AdminDeleteOrgUserParams,
  Label,
  LabelNew,
  DownloadMetricsParams,
  Metric,
  ListMetricsValuesParams,
  CalculateMetricsParams,
  MetricDesc,
  ListMetricDescriptionsParams,
  FindMetricValuesByIDParams,
  OrganizationUpdate,
  User,
  InvitationNew,
  OrgUserNew,
  OrganizationConfiguration,
  SearchResultsLabels,
  SearchLabelsParams,
  SearchResultsTeams,
  SearchTeamsParams,
  SearchResultsUsers,
  SearchUsersParams,
  Source,
  SourcesListParams,
  SourceNew,
  SourcesListUserSourcesParams,
  SourceSlackChannelsConfig,
  GmailQuery,
  GmailQueryNew,
  GmailQueryUpdate,
  GmailEmailSummary,
  SourceCalendar,
  SourcesGetCalendarsParams,
  SourceCalendarUpdate,
  SourceDocument,
  SourcesGetDocumentsParams,
  SourceDocumentNew,
  SourceDocumentUpdate,
  SearchScopeUpdate,
  Jira,
  SourcesListJiraParams,
  JiraNew,
  JiraConnection,
  JiraProject,
  JiraUpdate,
  JiraEpic,
  SourceValidate,
  SourcesValidateJiraByIdParams,
  SourcesValidateSalesforceByIdParams,
  SalesforceConnection,
  Salesforce,
  SourcesListSalesforceParams,
  SalesforceNew,
  SalesforceUpdate,
  Subscription,
  SubscriptionNew,
  Team,
  TeamsParams,
  TeamNew,
  TeamUpdate,
  TeamMember,
  TeamMembership,
  DeleteTeamMemberParams,
  TeamMembersParams,
  Twin,
  TwinInsightCategory,
  TwinInsightCategoryUpdate,
  TwinsListInsightCategoriesParams,
  TwinInsightCategoryNew,
  TwinDashboard,
  TwinUpdate,
  TwinsGetMultipleParams,
  TwinShare,
  TwinShareNew,
  TwinsAcceptShareParams,
  Skill,
  TwinsSuggestedQuestionsParams,
  TwinCrawlResult,
  TwinCrawlRequest,
  TwinDialogResult,
  TwinMessageNew,
  TwinsAskParams,
  TwinMessage,
  TwinMessageAnswer,
  TwinMessageFeedback,
  TwinsDialogParams,
  TwinsMobiusDialogParams,
  TwinQuestionResult,
  TwinQuestion,
  TwinsQuestionParams,
  TwinsMessagesParams,
  TwinConversationGroup,
  TwinsConversationsParams,
  TwinConversation,
  TwinsConversationParams,
  TwinsDeleteConversationParams,
  TwinsConversationViewedParams,
  TwinsConversationClearParams,
  TwinsConversationByTagParams,
  TwinConversationCounts,
  SearchResultsTwins,
  SearchTwinsParams,
  TwinNoteSummary,
  TwinsNotesParams,
  TwinNote,
  TwinNoteNew,
  TwinNoteUpdate,
  TwinDialogStreamResult,
  TwinInstruction,
  TwinInstructionUpdate,
  TwinInsightsWithLatest,
  TwinsListInsightsParams,
  Trend,
  TrendsListTrendsParams,
  TrendCompany,
  TrendTopic,
  TrendsGetTopicsParams,
  TrendsGetTopicTypesParams,
  TwinsListInstructionsParams,
  TwinInstructionNew,
  ShortUrlAvailability,
  TwinsValidateShortUrlParams,
  TwinPrompt,
  TwinsPromptsParams,
  TwinsResetPromptsParams,
  TwinPromptNew,
  TwinPromptUpdate,
  TwinsGetSuggestedDocumentsParams,
  TwinResponder,
  TwinResponderUpdate,
  TwinResponderLabel,
  TwinResponderStats,
  UsersGetTwinResponderStatsParams,
  TwinResponderThreads,
  UsersGetTwinResponderThreadsParams,
  TwinResponderThread,
  TwinResponderResult,
  TwinRespond,
  UsersGenerateTwinResponseParams,
  TwinRespondUpdate,
  UsersDeleteResponseDraftParams,
  TwinResponderContentResult,
  TwinRespondImprove,
  UsersGenerateTwinResponseContentParams,
  TwinConstructEmail,
  UsersConstructEmailParams,
  TwinConstructEmailUpdate,
  UsersGetAuthenticated200,
  UsersGetAuthenticatedParams,
  UserUpdate,
  UserFeedback,
  Feature,
  OrganizationNew,
  UserChangePassword,
  UserPermission,
  UsersCheckPermissionParams,
  Product,
  Notification,
  NotificationsGetUnreadCount200,
  NotificationSubscription,
  NotificationSettings,
  Comment,
  CommentNew,
  CommentUpdate,
  Prediction
} from '../model'

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


/**
 * impersonate the org and user id
 * @summary impersonate the org and user id
 */
export const adminImpersonate = (
    authImpersonate: AuthImpersonate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(
      `/api/v1/admin/impersonate`,
      authImpersonate,options
    );
  }



    export type AdminImpersonateMutationResult = NonNullable<Awaited<ReturnType<typeof adminImpersonate>>>
    export type AdminImpersonateMutationBody = AuthImpersonate
    export type AdminImpersonateMutationError = AxiosError<unknown>

    export const useAdminImpersonate = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminImpersonate>>, TError,{data: AuthImpersonate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminImpersonate>>, {data: AuthImpersonate}> = (props) => {
          const {data} = props ?? {};

          return  adminImpersonate(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminImpersonate>>, TError, {data: AuthImpersonate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List organizations for the system admin user.
 * @summary List organizations for the system admin user
 */
export const adminListOrgs = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull[]>> => {
    return axios.get(
      `/api/v1/admin/orgs`,options
    );
  }


export const getAdminListOrgsQueryKey = () => [`/api/v1/admin/orgs`];

    
export type AdminListOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListOrgs>>>
export type AdminListOrgsQueryError = AxiosError<unknown>

export const useAdminListOrgs = <TData = Awaited<ReturnType<typeof adminListOrgs>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListOrgs>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListOrgsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListOrgs>>> = ({ signal }) => adminListOrgs({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof adminListOrgs>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create an organization and add the authenticated admin user as an org user
 * @summary create an organization and add the authenticated admin user as an org user
 */
export const adminCreateOrg = (
    adminOrganizationNew: AdminOrganizationNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull>> => {
    return axios.post(
      `/api/v1/admin/orgs`,
      adminOrganizationNew,options
    );
  }



    export type AdminCreateOrgMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateOrg>>>
    export type AdminCreateOrgMutationBody = AdminOrganizationNew
    export type AdminCreateOrgMutationError = AxiosError<Failure>

    export const useAdminCreateOrg = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateOrg>>, TError,{data: AdminOrganizationNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateOrg>>, {data: AdminOrganizationNew}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateOrg(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminCreateOrg>>, TError, {data: AdminOrganizationNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update an organization as admin
 * @summary Update an organization as admin
 */
export const adminUpdateOrg = (
    org: string,
    adminOrganizationUpdate: AdminOrganizationUpdate,
    params: AdminUpdateOrgParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull>> => {
    return axios.patch(
      `/api/v1/admin/orgs/${org}`,
      adminOrganizationUpdate,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type AdminUpdateOrgMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdateOrg>>>
    export type AdminUpdateOrgMutationBody = AdminOrganizationUpdate
    export type AdminUpdateOrgMutationError = AxiosError<Failure>

    export const useAdminUpdateOrg = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdateOrg>>, TError,{org: string;data: AdminOrganizationUpdate;params: AdminUpdateOrgParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdateOrg>>, {org: string;data: AdminOrganizationUpdate;params: AdminUpdateOrgParams}> = (props) => {
          const {org,data,params} = props ?? {};

          return  adminUpdateOrg(org,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminUpdateOrg>>, TError, {org: string;data: AdminOrganizationUpdate;params: AdminUpdateOrgParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete organization
 * @summary delete organization
 */
export const adminDeleteOrg = (
    org: string,
    adminOrganizationDelete: AdminOrganizationDelete,
    params: AdminDeleteOrgParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/admin/orgs/${org}`,{data:
      adminOrganizationDelete, 
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type AdminDeleteOrgMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteOrg>>>
    export type AdminDeleteOrgMutationBody = AdminOrganizationDelete
    export type AdminDeleteOrgMutationError = AxiosError<Failure>

    export const useAdminDeleteOrg = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteOrg>>, TError,{org: string;data: AdminOrganizationDelete;params: AdminDeleteOrgParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteOrg>>, {org: string;data: AdminOrganizationDelete;params: AdminDeleteOrgParams}> = (props) => {
          const {org,data,params} = props ?? {};

          return  adminDeleteOrg(org,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminDeleteOrg>>, TError, {org: string;data: AdminOrganizationDelete;params: AdminDeleteOrgParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * upload a photo for the org as an jelled admin
 * @summary upload a photo for the org as an admin
 */
export const adminUploadOrgPicture = (
    org: string,
    adminUploadOrgPictureBody: Blob, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Picture>> => {
    return axios.post(
      `/api/v1/admin/orgs/${org}/picture`,
      adminUploadOrgPictureBody,options
    );
  }



    export type AdminUploadOrgPictureMutationResult = NonNullable<Awaited<ReturnType<typeof adminUploadOrgPicture>>>
    export type AdminUploadOrgPictureMutationBody = Blob
    export type AdminUploadOrgPictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useAdminUploadOrgPicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUploadOrgPicture>>, TError,{org: string;data: Blob}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUploadOrgPicture>>, {org: string;data: Blob}> = (props) => {
          const {org,data} = props ?? {};

          return  adminUploadOrgPicture(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminUploadOrgPicture>>, TError, {org: string;data: Blob}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete a picture for the org as an admin
 * @summary delete org picture as an admin
 */
export const adminDeleteOrgPicture = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/admin/orgs/${org}/picture`,options
    );
  }



    export type AdminDeleteOrgPictureMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteOrgPicture>>>
    
    export type AdminDeleteOrgPictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useAdminDeleteOrgPicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteOrgPicture>>, TError,{org: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteOrgPicture>>, {org: string}> = (props) => {
          const {org} = props ?? {};

          return  adminDeleteOrgPicture(org,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminDeleteOrgPicture>>, TError, {org: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Find orgs via various criteria. This method returns up to 100 results [per page](https://docs.github.com/rest/overview/resources-in-the-rest-api#pagination).

When searching for users, you can get text match metadata for the issue **login**, **email**, and **name** fields when you pass the `text-match` media type. For more details about highlighting search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata). For more details about how to receive highlighted search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata).

For example, if you're looking for a list of popular users, you might try this query:

`q=tom+repos:%3E42+followers:%3E1000`

This query searches for users with the name `tom`. The results are restricted to users with more than 42 repositories and over 1,000 followers.
 * @summary Search orgs
 */
export const adminSearchOrgs = (
    params: AdminSearchOrgsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchResultsOrgs>> => {
    return axios.get(
      `/api/v1/admin/search/orgs`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAdminSearchOrgsQueryKey = (params: AdminSearchOrgsParams,) => [`/api/v1/admin/search/orgs`, ...(params ? [params]: [])];

    
export type AdminSearchOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof adminSearchOrgs>>>
export type AdminSearchOrgsQueryError = AxiosError<NotModifiedResponse | ValidationFailedResponse>

export const useAdminSearchOrgs = <TData = Awaited<ReturnType<typeof adminSearchOrgs>>, TError = AxiosError<NotModifiedResponse | ValidationFailedResponse>>(
 params: AdminSearchOrgsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSearchOrgs>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSearchOrgsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSearchOrgs>>> = ({ signal }) => adminSearchOrgs(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof adminSearchOrgs>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * List waitlists for the system admin user.
 * @summary List waitlists for the system admin user
 */
export const adminListWaitlist = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WaitlistEntry[]>> => {
    return axios.get(
      `/api/v1/admin/waitlist`,options
    );
  }


export const getAdminListWaitlistQueryKey = () => [`/api/v1/admin/waitlist`];

    
export type AdminListWaitlistQueryResult = NonNullable<Awaited<ReturnType<typeof adminListWaitlist>>>
export type AdminListWaitlistQueryError = AxiosError<unknown>

export const useAdminListWaitlist = <TData = Awaited<ReturnType<typeof adminListWaitlist>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListWaitlist>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListWaitlistQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListWaitlist>>> = ({ signal }) => adminListWaitlist({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof adminListWaitlist>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a waitlist entry
 * @summary create a waitlist entry
 */
export const adminCreateWaitlist = (
    waitlistEntryNew: WaitlistEntryNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WaitlistEntry>> => {
    return axios.post(
      `/api/v1/admin/waitlist`,
      waitlistEntryNew,options
    );
  }



    export type AdminCreateWaitlistMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreateWaitlist>>>
    export type AdminCreateWaitlistMutationBody = WaitlistEntryNew
    export type AdminCreateWaitlistMutationError = AxiosError<Failure>

    export const useAdminCreateWaitlist = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreateWaitlist>>, TError,{data: WaitlistEntryNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreateWaitlist>>, {data: WaitlistEntryNew}> = (props) => {
          const {data} = props ?? {};

          return  adminCreateWaitlist(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminCreateWaitlist>>, TError, {data: WaitlistEntryNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Remove a waitlist entry
 * @summary Remove a waitlist entry
 */
export const adminRemoveWaitlist = (
    params: AdminRemoveWaitlistParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/admin/waitlist`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type AdminRemoveWaitlistMutationResult = NonNullable<Awaited<ReturnType<typeof adminRemoveWaitlist>>>
    
    export type AdminRemoveWaitlistMutationError = AxiosError<NotFoundResponse>

    export const useAdminRemoveWaitlist = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRemoveWaitlist>>, TError,{params: AdminRemoveWaitlistParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRemoveWaitlist>>, {params: AdminRemoveWaitlistParams}> = (props) => {
          const {params} = props ?? {};

          return  adminRemoveWaitlist(params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminRemoveWaitlist>>, TError, {params: AdminRemoveWaitlistParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete user from the organization
 * @summary delete user from the organization
 */
export const adminDeleteOrgUser = (
    org: string,
    adminUserDelete: AdminUserDelete,
    params: AdminDeleteOrgUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/admin/orgs/${org}/user`,{data:
      adminUserDelete, 
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type AdminDeleteOrgUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteOrgUser>>>
    export type AdminDeleteOrgUserMutationBody = AdminUserDelete
    export type AdminDeleteOrgUserMutationError = AxiosError<Failure>

    export const useAdminDeleteOrgUser = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteOrgUser>>, TError,{org: string;data: AdminUserDelete;params: AdminDeleteOrgUserParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteOrgUser>>, {org: string;data: AdminUserDelete;params: AdminDeleteOrgUserParams}> = (props) => {
          const {org,data,params} = props ?? {};

          return  adminDeleteOrgUser(org,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof adminDeleteOrgUser>>, TError, {org: string;data: AdminUserDelete;params: AdminDeleteOrgUserParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List labels
 * @summary List labels
 */
export const labelsListForAuthenticatedUser = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Label[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/labels`,options
    );
  }


export const getLabelsListForAuthenticatedUserQueryKey = (org: string,) => [`/api/v1/orgs/${org}/labels`];

    
export type LabelsListForAuthenticatedUserQueryResult = NonNullable<Awaited<ReturnType<typeof labelsListForAuthenticatedUser>>>
export type LabelsListForAuthenticatedUserQueryError = AxiosError<unknown>

export const useLabelsListForAuthenticatedUser = <TData = Awaited<ReturnType<typeof labelsListForAuthenticatedUser>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof labelsListForAuthenticatedUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLabelsListForAuthenticatedUserQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof labelsListForAuthenticatedUser>>> = ({ signal }) => labelsListForAuthenticatedUser(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof labelsListForAuthenticatedUser>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a label for the authenticated user and the org.
 * @summary create a label for the authenticated user
 */
export const labelsCreateForAuthenticatedUser = (
    org: string,
    labelNew: LabelNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Label>> => {
    return axios.post(
      `/api/v1/orgs/${org}/labels`,
      labelNew,options
    );
  }



    export type LabelsCreateForAuthenticatedUserMutationResult = NonNullable<Awaited<ReturnType<typeof labelsCreateForAuthenticatedUser>>>
    export type LabelsCreateForAuthenticatedUserMutationBody = LabelNew
    export type LabelsCreateForAuthenticatedUserMutationError = AxiosError<Failure>

    export const useLabelsCreateForAuthenticatedUser = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof labelsCreateForAuthenticatedUser>>, TError,{org: string;data: LabelNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof labelsCreateForAuthenticatedUser>>, {org: string;data: LabelNew}> = (props) => {
          const {org,data} = props ?? {};

          return  labelsCreateForAuthenticatedUser(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof labelsCreateForAuthenticatedUser>>, TError, {org: string;data: LabelNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Delete a label specified in path
 * @summary Delete a label
 */
export const labelsDeleteLabel = (
    org: string,
    labelId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/labels/${labelId}`,options
    );
  }



    export type LabelsDeleteLabelMutationResult = NonNullable<Awaited<ReturnType<typeof labelsDeleteLabel>>>
    
    export type LabelsDeleteLabelMutationError = AxiosError<NotFoundResponse>

    export const useLabelsDeleteLabel = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof labelsDeleteLabel>>, TError,{org: string;labelId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof labelsDeleteLabel>>, {org: string;labelId: string}> = (props) => {
          const {org,labelId} = props ?? {};

          return  labelsDeleteLabel(org,labelId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof labelsDeleteLabel>>, TError, {org: string;labelId: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a file with metrics
 * @summary Returns a file with metrics
 */
export const downloadMetrics = (
    org: string,
    params: DownloadMetricsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axios.get(
      `/api/v1/orgs/${org}/metrics/download`,{
        responseType: 'blob',
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getDownloadMetricsQueryKey = (org: string,
    params: DownloadMetricsParams,) => [`/api/v1/orgs/${org}/metrics/download`, ...(params ? [params]: [])];

    
export type DownloadMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof downloadMetrics>>>
export type DownloadMetricsQueryError = AxiosError<Failure>

export const useDownloadMetrics = <TData = Awaited<ReturnType<typeof downloadMetrics>>, TError = AxiosError<Failure>>(
 org: string,
    params: DownloadMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadMetrics>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadMetricsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadMetrics>>> = ({ signal }) => downloadMetrics(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof downloadMetrics>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a metric values
 * @summary Returns a metric values
 */
export const listMetricsValues = (
    org: string,
    params?: ListMetricsValuesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Metric[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/metrics/values`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListMetricsValuesQueryKey = (org: string,
    params?: ListMetricsValuesParams,) => [`/api/v1/orgs/${org}/metrics/values`, ...(params ? [params]: [])];

    
export type ListMetricsValuesQueryResult = NonNullable<Awaited<ReturnType<typeof listMetricsValues>>>
export type ListMetricsValuesQueryError = AxiosError<Failure>

export const useListMetricsValues = <TData = Awaited<ReturnType<typeof listMetricsValues>>, TError = AxiosError<Failure>>(
 org: string,
    params?: ListMetricsValuesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMetricsValues>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricsValuesQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetricsValues>>> = ({ signal }) => listMetricsValues(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listMetricsValues>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * force calculate metrics online
 * @summary force calculate metrics online
 */
export const calculateMetrics = (
    org: string,
    params: CalculateMetricsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Metric[]>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/metrics/values`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type CalculateMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof calculateMetrics>>>
    
    export type CalculateMetricsMutationError = AxiosError<Failure>

    export const useCalculateMetrics = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateMetrics>>, TError,{org: string;params: CalculateMetricsParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculateMetrics>>, {org: string;params: CalculateMetricsParams}> = (props) => {
          const {org,params} = props ?? {};

          return  calculateMetrics(org,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof calculateMetrics>>, TError, {org: string;params: CalculateMetricsParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a metric descriptions
 * @summary Returns a metric descriptions
 */
export const listMetricDescriptions = (
    org: string,
    params?: ListMetricDescriptionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MetricDesc[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/metrics/descriptions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListMetricDescriptionsQueryKey = (org: string,
    params?: ListMetricDescriptionsParams,) => [`/api/v1/orgs/${org}/metrics/descriptions`, ...(params ? [params]: [])];

    
export type ListMetricDescriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listMetricDescriptions>>>
export type ListMetricDescriptionsQueryError = AxiosError<Failure>

export const useListMetricDescriptions = <TData = Awaited<ReturnType<typeof listMetricDescriptions>>, TError = AxiosError<Failure>>(
 org: string,
    params?: ListMetricDescriptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMetricDescriptions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricDescriptionsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetricDescriptions>>> = ({ signal }) => listMetricDescriptions(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listMetricDescriptions>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a metric value by Id
 * @summary Returns a metric value by Id
 */
export const findMetricValuesByID = (
    org: string,
    id: string,
    params?: FindMetricValuesByIDParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Metric[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/metric/${id}/values`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getFindMetricValuesByIDQueryKey = (org: string,
    id: string,
    params?: FindMetricValuesByIDParams,) => [`/api/v1/orgs/${org}/metric/${id}/values`, ...(params ? [params]: [])];

    
export type FindMetricValuesByIDQueryResult = NonNullable<Awaited<ReturnType<typeof findMetricValuesByID>>>
export type FindMetricValuesByIDQueryError = AxiosError<Failure>

export const useFindMetricValuesByID = <TData = Awaited<ReturnType<typeof findMetricValuesByID>>, TError = AxiosError<Failure>>(
 org: string,
    id: string,
    params?: FindMetricValuesByIDParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findMetricValuesByID>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindMetricValuesByIDQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findMetricValuesByID>>> = ({ signal }) => findMetricValuesByID(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof findMetricValuesByID>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a metric description by Id
 * @summary Returns a metric description by Id
 */
export const findMetricDescriptionByID = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MetricDesc | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/metric/${id}/description`,options
    );
  }


export const getFindMetricDescriptionByIDQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/metric/${id}/description`];

    
export type FindMetricDescriptionByIDQueryResult = NonNullable<Awaited<ReturnType<typeof findMetricDescriptionByID>>>
export type FindMetricDescriptionByIDQueryError = AxiosError<Failure>

export const useFindMetricDescriptionByID = <TData = Awaited<ReturnType<typeof findMetricDescriptionByID>>, TError = AxiosError<Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof findMetricDescriptionByID>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindMetricDescriptionByIDQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findMetricDescriptionByID>>> = ({ signal }) => findMetricDescriptionByID(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof findMetricDescriptionByID>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * To see many of the organization response values, you need to be an authenticated organization owner with the `org:w` scope.
 * @summary Get an organization
 */
export const orgsGet = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull>> => {
    return axios.get(
      `/api/v1/orgs/${org}`,options
    );
  }


export const getOrgsGetQueryKey = (org: string,) => [`/api/v1/orgs/${org}`];

    
export type OrgsGetQueryResult = NonNullable<Awaited<ReturnType<typeof orgsGet>>>
export type OrgsGetQueryError = AxiosError<NotFoundResponse>

export const useOrgsGet = <TData = Awaited<ReturnType<typeof orgsGet>>, TError = AxiosError<NotFoundResponse>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof orgsGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrgsGetQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orgsGet>>> = ({ signal }) => orgsGet(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof orgsGet>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization owner with the `org:w` scope to update the organization's profile.
 * @summary Update an organization
 */
export const orgsUpdate = (
    org: string,
    organizationUpdate: OrganizationUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull>> => {
    return axios.patch(
      `/api/v1/orgs/${org}`,
      organizationUpdate,options
    );
  }



    export type OrgsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof orgsUpdate>>>
    export type OrgsUpdateMutationBody = OrganizationUpdate
    export type OrgsUpdateMutationError = AxiosError<Failure>

    export const useOrgsUpdate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsUpdate>>, TError,{org: string;data: OrganizationUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsUpdate>>, {org: string;data: OrganizationUpdate}> = (props) => {
          const {org,data} = props ?? {};

          return  orgsUpdate(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsUpdate>>, TError, {org: string;data: OrganizationUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * upload a photo for the org
 * @summary upload a photo for the org
 */
export const orgsUploadPicture = (
    org: string,
    orgsUploadPictureBody: Blob, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Picture>> => {
    return axios.post(
      `/api/v1/orgs/${org}/picture`,
      orgsUploadPictureBody,options
    );
  }



    export type OrgsUploadPictureMutationResult = NonNullable<Awaited<ReturnType<typeof orgsUploadPicture>>>
    export type OrgsUploadPictureMutationBody = Blob
    export type OrgsUploadPictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useOrgsUploadPicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsUploadPicture>>, TError,{org: string;data: Blob}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsUploadPicture>>, {org: string;data: Blob}> = (props) => {
          const {org,data} = props ?? {};

          return  orgsUploadPicture(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsUploadPicture>>, TError, {org: string;data: Blob}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete a picture for the org
 * @summary delete org picture
 */
export const orgsDeletePicture = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/picture`,options
    );
  }



    export type OrgsDeletePictureMutationResult = NonNullable<Awaited<ReturnType<typeof orgsDeletePicture>>>
    
    export type OrgsDeletePictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useOrgsDeletePicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsDeletePicture>>, TError,{org: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsDeletePicture>>, {org: string}> = (props) => {
          const {org} = props ?? {};

          return  orgsDeletePicture(org,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsDeletePicture>>, TError, {org: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List organization members
 * @summary List organization members
 */
export const orgsListMembers = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/members`,options
    );
  }


export const getOrgsListMembersQueryKey = (org: string,) => [`/api/v1/orgs/${org}/members`];

    
export type OrgsListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof orgsListMembers>>>
export type OrgsListMembersQueryError = AxiosError<unknown>

export const useOrgsListMembers = <TData = Awaited<ReturnType<typeof orgsListMembers>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof orgsListMembers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrgsListMembersQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orgsListMembers>>> = ({ signal }) => orgsListMembers(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof orgsListMembers>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * add an user to the org
 * @summary add an user to the org
 */
export const orgsAddMember = (
    org: string,
    invitationNew: InvitationNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    return axios.put(
      `/api/v1/orgs/${org}/members`,
      invitationNew,options
    );
  }



    export type OrgsAddMemberMutationResult = NonNullable<Awaited<ReturnType<typeof orgsAddMember>>>
    export type OrgsAddMemberMutationBody = InvitationNew
    export type OrgsAddMemberMutationError = AxiosError<NotFoundResponse>

    export const useOrgsAddMember = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsAddMember>>, TError,{org: string;data: InvitationNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsAddMember>>, {org: string;data: InvitationNew}> = (props) => {
          const {org,data} = props ?? {};

          return  orgsAddMember(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsAddMember>>, TError, {org: string;data: InvitationNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * accept an invitation for the org in path.
 * @summary accept an invitation for the org in path
 */
export const orgsAcceptInvitation = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/members`,undefined,options
    );
  }



    export type OrgsAcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof orgsAcceptInvitation>>>
    
    export type OrgsAcceptInvitationMutationError = AxiosError<Failure>

    export const useOrgsAcceptInvitation = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsAcceptInvitation>>, TError,{org: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsAcceptInvitation>>, {org: string}> = (props) => {
          const {org} = props ?? {};

          return  orgsAcceptInvitation(org,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsAcceptInvitation>>, TError, {org: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Remove an user from the org
 * @summary Remove an user from the org
 */
export const orgsRemoveMember = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/members/${id}`,options
    );
  }



    export type OrgsRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof orgsRemoveMember>>>
    
    export type OrgsRemoveMemberMutationError = AxiosError<NotFoundResponse>

    export const useOrgsRemoveMember = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsRemoveMember>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsRemoveMember>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  orgsRemoveMember(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsRemoveMember>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * add an user to the org
 * @summary add an user to the org
 */
export const orgsAddMemberById = (
    org: string,
    id: string,
    orgUserNew: OrgUserNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `/api/v1/orgs/${org}/members/${id}`,
      orgUserNew,options
    );
  }



    export type OrgsAddMemberByIdMutationResult = NonNullable<Awaited<ReturnType<typeof orgsAddMemberById>>>
    export type OrgsAddMemberByIdMutationBody = OrgUserNew
    export type OrgsAddMemberByIdMutationError = AxiosError<NotFoundResponse>

    export const useOrgsAddMemberById = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsAddMemberById>>, TError,{org: string;id: string;data: OrgUserNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsAddMemberById>>, {org: string;id: string;data: OrgUserNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  orgsAddMemberById(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsAddMemberById>>, TError, {org: string;id: string;data: OrgUserNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * resend invite
 * @summary resend invite
 */
export const orgsResendInvitation = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/members/${id}`,undefined,options
    );
  }



    export type OrgsResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof orgsResendInvitation>>>
    
    export type OrgsResendInvitationMutationError = AxiosError<NotFoundResponse>

    export const useOrgsResendInvitation = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsResendInvitation>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsResendInvitation>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  orgsResendInvitation(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsResendInvitation>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * update user membership
 * @summary update user membership
 */
export const orgsUpdateMember = (
    org: string,
    id: string,
    orgUserNew: OrgUserNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/members/${id}`,
      orgUserNew,options
    );
  }



    export type OrgsUpdateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof orgsUpdateMember>>>
    export type OrgsUpdateMemberMutationBody = OrgUserNew
    export type OrgsUpdateMemberMutationError = AxiosError<NotFoundResponse>

    export const useOrgsUpdateMember = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsUpdateMember>>, TError,{org: string;id: string;data: OrgUserNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsUpdateMember>>, {org: string;id: string;data: OrgUserNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  orgsUpdateMember(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsUpdateMember>>, TError, {org: string;id: string;data: OrgUserNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * create configuration for org
 * @summary create/update configuration for org
 */
export const orgsCreateConfiguration = (
    org: string,
    organizationConfiguration: OrganizationConfiguration, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationConfiguration>> => {
    return axios.post(
      `/api/v1/orgs/${org}/configuration`,
      organizationConfiguration,options
    );
  }



    export type OrgsCreateConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof orgsCreateConfiguration>>>
    export type OrgsCreateConfigurationMutationBody = OrganizationConfiguration
    export type OrgsCreateConfigurationMutationError = AxiosError<NotFoundResponse | Failure>

    export const useOrgsCreateConfiguration = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsCreateConfiguration>>, TError,{org: string;data: OrganizationConfiguration}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsCreateConfiguration>>, {org: string;data: OrganizationConfiguration}> = (props) => {
          const {org,data} = props ?? {};

          return  orgsCreateConfiguration(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsCreateConfiguration>>, TError, {org: string;data: OrganizationConfiguration}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * get configuration for org
 * @summary get configuration for org
 */
export const orgsGetConfiguration = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationConfiguration>> => {
    return axios.get(
      `/api/v1/orgs/${org}/configuration`,options
    );
  }


export const getOrgsGetConfigurationQueryKey = (org: string,) => [`/api/v1/orgs/${org}/configuration`];

    
export type OrgsGetConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof orgsGetConfiguration>>>
export type OrgsGetConfigurationQueryError = AxiosError<NotFoundResponse | Failure>

export const useOrgsGetConfiguration = <TData = Awaited<ReturnType<typeof orgsGetConfiguration>>, TError = AxiosError<NotFoundResponse | Failure>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof orgsGetConfiguration>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrgsGetConfigurationQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orgsGetConfiguration>>> = ({ signal }) => orgsGetConfiguration(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof orgsGetConfiguration>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Find labels via various criteria.
 * @summary Search labels
 */
export const searchLabels = (
    org: string,
    params: SearchLabelsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchResultsLabels>> => {
    return axios.get(
      `/api/v1/orgs/${org}/search/labels`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSearchLabelsQueryKey = (org: string,
    params: SearchLabelsParams,) => [`/api/v1/orgs/${org}/search/labels`, ...(params ? [params]: [])];

    
export type SearchLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof searchLabels>>>
export type SearchLabelsQueryError = AxiosError<NotModifiedResponse | ValidationFailedResponse>

export const useSearchLabels = <TData = Awaited<ReturnType<typeof searchLabels>>, TError = AxiosError<NotModifiedResponse | ValidationFailedResponse>>(
 org: string,
    params: SearchLabelsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchLabels>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchLabelsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLabels>>> = ({ signal }) => searchLabels(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof searchLabels>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Find users via various criteria. This method returns up to 100 results [per page](https://docs.github.com/rest/overview/resources-in-the-rest-api#pagination).

When searching for users, you can get text match metadata for the issue **login**, **email**, and **name** fields when you pass the `text-match` media type. For more details about highlighting search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata). For more details about how to receive highlighted search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata).

For example, if you're looking for a list of popular users, you might try this query:

`q=tom+repos:%3E42+followers:%3E1000`

This query searches for users with the name `tom`. The results are restricted to users with more than 42 repositories and over 1,000 followers.
 * @summary Search teams
 */
export const searchTeams = (
    org: string,
    params: SearchTeamsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchResultsTeams>> => {
    return axios.get(
      `/api/v1/orgs/${org}/search/teams`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSearchTeamsQueryKey = (org: string,
    params: SearchTeamsParams,) => [`/api/v1/orgs/${org}/search/teams`, ...(params ? [params]: [])];

    
export type SearchTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof searchTeams>>>
export type SearchTeamsQueryError = AxiosError<NotModifiedResponse | ValidationFailedResponse>

export const useSearchTeams = <TData = Awaited<ReturnType<typeof searchTeams>>, TError = AxiosError<NotModifiedResponse | ValidationFailedResponse>>(
 org: string,
    params: SearchTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchTeams>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchTeamsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchTeams>>> = ({ signal }) => searchTeams(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof searchTeams>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Find users via various criteria. This method returns up to 100 results [per page](https://docs.github.com/rest/overview/resources-in-the-rest-api#pagination).

When searching for users, you can get text match metadata for the issue **login**, **email**, and **name** fields when you pass the `text-match` media type. For more details about highlighting search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata). For more details about how to receive highlighted search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata).

For example, if you're looking for a list of popular users, you might try this query:

`q=tom+repos:%3E42+followers:%3E1000`

This query searches for users with the name `tom`. The results are restricted to users with more than 42 repositories and over 1,000 followers.
 * @summary Search users
 */
export const searchUsers = (
    org: string,
    params: SearchUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchResultsUsers>> => {
    return axios.get(
      `/api/v1/orgs/${org}/search/users`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSearchUsersQueryKey = (org: string,
    params: SearchUsersParams,) => [`/api/v1/orgs/${org}/search/users`, ...(params ? [params]: [])];

    
export type SearchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersQueryError = AxiosError<NotModifiedResponse | ValidationFailedResponse>

export const useSearchUsers = <TData = Awaited<ReturnType<typeof searchUsers>>, TError = AxiosError<NotModifiedResponse | ValidationFailedResponse>>(
 org: string,
    params: SearchUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchUsersQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsers>>> = ({ signal }) => searchUsers(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof searchUsers>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * List sources
 * @summary List sources
 */
export const sourcesList = (
    org: string,
    params?: SourcesListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/sources`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesListQueryKey = (org: string,
    params?: SourcesListParams,) => [`/api/v1/orgs/${org}/sources`, ...(params ? [params]: [])];

    
export type SourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesList>>>
export type SourcesListQueryError = AxiosError<unknown>

export const useSourcesList = <TData = Awaited<ReturnType<typeof sourcesList>>, TError = AxiosError<unknown>>(
 org: string,
    params?: SourcesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesListQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesList>>> = ({ signal }) => sourcesList(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesList>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a sources for the authenticated user and the org.
 * @summary create a sources for the authenticated user
 */
export const sourcesCreate = (
    org: string,
    sourceNew: SourceNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source>> => {
    return axios.post(
      `/api/v1/orgs/${org}/sources`,
      sourceNew,options
    );
  }



    export type SourcesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesCreate>>>
    export type SourcesCreateMutationBody = SourceNew
    export type SourcesCreateMutationError = AxiosError<Failure>

    export const useSourcesCreate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesCreate>>, TError,{org: string;data: SourceNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesCreate>>, {org: string;data: SourceNew}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesCreate(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesCreate>>, TError, {org: string;data: SourceNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List sources
 * @summary List sources
 */
export const sourcesListUserSources = (
    org: string,
    params?: SourcesListUserSourcesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/sources/user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesListUserSourcesQueryKey = (org: string,
    params?: SourcesListUserSourcesParams,) => [`/api/v1/orgs/${org}/sources/user`, ...(params ? [params]: [])];

    
export type SourcesListUserSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesListUserSources>>>
export type SourcesListUserSourcesQueryError = AxiosError<unknown>

export const useSourcesListUserSources = <TData = Awaited<ReturnType<typeof sourcesListUserSources>>, TError = AxiosError<unknown>>(
 org: string,
    params?: SourcesListUserSourcesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesListUserSources>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesListUserSourcesQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesListUserSources>>> = ({ signal }) => sourcesListUserSources(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesListUserSources>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a sources for the authenticated user and the org.
 * @summary create a sources for the authenticated user
 */
export const sourcesCreateUserSource = (
    org: string,
    sourceNew: SourceNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source>> => {
    return axios.post(
      `/api/v1/orgs/${org}/sources/user`,
      sourceNew,options
    );
  }



    export type SourcesCreateUserSourceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesCreateUserSource>>>
    export type SourcesCreateUserSourceMutationBody = SourceNew
    export type SourcesCreateUserSourceMutationError = AxiosError<Failure>

    export const useSourcesCreateUserSource = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesCreateUserSource>>, TError,{org: string;data: SourceNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesCreateUserSource>>, {org: string;data: SourceNew}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesCreateUserSource(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesCreateUserSource>>, TError, {org: string;data: SourceNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get a source specified in path
 * @summary Get a source
 */
export const sourcesGet = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source>> => {
    return axios.get(
      `/api/v1/orgs/${org}/sources/${id}`,options
    );
  }


export const getSourcesGetQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/sources/${id}`];

    
export type SourcesGetQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGet>>>
export type SourcesGetQueryError = AxiosError<NotFoundResponse>

export const useSourcesGet = <TData = Awaited<ReturnType<typeof sourcesGet>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGet>>> = ({ signal }) => sourcesGet(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGet>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update a source specified in path
 * @summary Update a source
 */
export const sourcesUpdate = (
    org: string,
    id: string,
    sourceNew: SourceNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/sources/${id}`,
      sourceNew,options
    );
  }



    export type SourcesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdate>>>
    export type SourcesUpdateMutationBody = SourceNew
    export type SourcesUpdateMutationError = AxiosError<NotFoundResponse>

    export const useSourcesUpdate = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdate>>, TError,{org: string;id: string;data: SourceNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdate>>, {org: string;id: string;data: SourceNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesUpdate(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdate>>, TError, {org: string;id: string;data: SourceNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Upload content for a source specified in path
 * @summary Upload content for a source
 */
export const sourcesUpload = (
    org: string,
    id: string,
    sourcesUploadBody: Blob, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source>> => {
    return axios.post(
      `/api/v1/orgs/${org}/sources/${id}`,
      sourcesUploadBody,options
    );
  }



    export type SourcesUploadMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpload>>>
    export type SourcesUploadMutationBody = Blob
    export type SourcesUploadMutationError = AxiosError<NotFoundResponse>

    export const useSourcesUpload = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpload>>, TError,{org: string;id: string;data: Blob}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpload>>, {org: string;id: string;data: Blob}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesUpload(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpload>>, TError, {org: string;id: string;data: Blob}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Delete a source specified in path
 * @summary Delete a source
 */
export const sourcesDelete = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/sources/${id}`,options
    );
  }



    export type SourcesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDelete>>>
    
    export type SourcesDeleteMutationError = AxiosError<NotFoundResponse>

    export const useSourcesDelete = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDelete>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDelete>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  sourcesDelete(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDelete>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get a source specified in path
 * @summary Get a source
 */
export const sourcesGetUserSource = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source>> => {
    return axios.get(
      `/api/v1/orgs/${org}/sources/${id}/user`,options
    );
  }


export const getSourcesGetUserSourceQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/sources/${id}/user`];

    
export type SourcesGetUserSourceQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetUserSource>>>
export type SourcesGetUserSourceQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetUserSource = <TData = Awaited<ReturnType<typeof sourcesGetUserSource>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetUserSource>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetUserSourceQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetUserSource>>> = ({ signal }) => sourcesGetUserSource(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetUserSource>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update a source specified in path
 * @summary Update a source
 */
export const sourcesUpdateUserSource = (
    org: string,
    id: string,
    sourceNew: SourceNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/sources/${id}/user`,
      sourceNew,options
    );
  }



    export type SourcesUpdateUserSourceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateUserSource>>>
    export type SourcesUpdateUserSourceMutationBody = SourceNew
    export type SourcesUpdateUserSourceMutationError = AxiosError<NotFoundResponse>

    export const useSourcesUpdateUserSource = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateUserSource>>, TError,{org: string;id: string;data: SourceNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateUserSource>>, {org: string;id: string;data: SourceNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesUpdateUserSource(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateUserSource>>, TError, {org: string;id: string;data: SourceNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Upload content for a source specified in path
 * @summary Upload content for a source
 */
export const sourcesUploadUserSource = (
    org: string,
    id: string,
    sourcesUploadUserSourceBody: Blob, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Source>> => {
    return axios.post(
      `/api/v1/orgs/${org}/sources/${id}/user`,
      sourcesUploadUserSourceBody,options
    );
  }



    export type SourcesUploadUserSourceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUploadUserSource>>>
    export type SourcesUploadUserSourceMutationBody = Blob
    export type SourcesUploadUserSourceMutationError = AxiosError<NotFoundResponse>

    export const useSourcesUploadUserSource = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUploadUserSource>>, TError,{org: string;id: string;data: Blob}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUploadUserSource>>, {org: string;id: string;data: Blob}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesUploadUserSource(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUploadUserSource>>, TError, {org: string;id: string;data: Blob}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Delete a source specified in path
 * @summary Delete a source
 */
export const sourcesDeleteUserSource = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/sources/${id}/user`,options
    );
  }



    export type SourcesDeleteUserSourceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteUserSource>>>
    
    export type SourcesDeleteUserSourceMutationError = AxiosError<NotFoundResponse>

    export const useSourcesDeleteUserSource = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteUserSource>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteUserSource>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  sourcesDeleteUserSource(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteUserSource>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a list of channels we look at for slack
 * @summary get slack channel configuration
 */
export const sourcesGetChannelsConfig = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceSlackChannelsConfig>> => {
    return axios.get(
      `/api/v1/orgs/${org}/sources/slack/channels-config`,options
    );
  }


export const getSourcesGetChannelsConfigQueryKey = (org: string,) => [`/api/v1/orgs/${org}/sources/slack/channels-config`];

    
export type SourcesGetChannelsConfigQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetChannelsConfig>>>
export type SourcesGetChannelsConfigQueryError = AxiosError<unknown>

export const useSourcesGetChannelsConfig = <TData = Awaited<ReturnType<typeof sourcesGetChannelsConfig>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetChannelsConfig>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetChannelsConfigQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetChannelsConfig>>> = ({ signal }) => sourcesGetChannelsConfig(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetChannelsConfig>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Updates slack channel configuration
 * @summary Update slack channel configuration
 */
export const sourcesUpdateChannelsConfig = (
    org: string,
    sourceSlackChannelsConfig: SourceSlackChannelsConfig, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceSlackChannelsConfig>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/sources/slack/channels-config`,
      sourceSlackChannelsConfig,options
    );
  }



    export type SourcesUpdateChannelsConfigMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateChannelsConfig>>>
    export type SourcesUpdateChannelsConfigMutationBody = SourceSlackChannelsConfig
    export type SourcesUpdateChannelsConfigMutationError = AxiosError<unknown>

    export const useSourcesUpdateChannelsConfig = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateChannelsConfig>>, TError,{org: string;data: SourceSlackChannelsConfig}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateChannelsConfig>>, {org: string;data: SourceSlackChannelsConfig}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesUpdateChannelsConfig(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateChannelsConfig>>, TError, {org: string;data: SourceSlackChannelsConfig}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a gmail query
 * @summary fetch a list of gmail filters
 */
export const sourcesGetGmailQueries = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GmailQuery[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/source/${id}/gmail`,options
    );
  }


export const getSourcesGetGmailQueriesQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/source/${id}/gmail`];

    
export type SourcesGetGmailQueriesQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetGmailQueries>>>
export type SourcesGetGmailQueriesQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetGmailQueries = <TData = Awaited<ReturnType<typeof sourcesGetGmailQueries>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetGmailQueries>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetGmailQueriesQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetGmailQueries>>> = ({ signal }) => sourcesGetGmailQueries(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetGmailQueries>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization user with the `org:w` scope to update a jira source.
 * @summary Create a gmail query by id
 */
export const sourcesNewGmailQuery = (
    org: string,
    id: string,
    gmailQueryNew: GmailQueryNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GmailQuery>> => {
    return axios.post(
      `/api/v1/orgs/${org}/source/${id}/gmail`,
      gmailQueryNew,options
    );
  }



    export type SourcesNewGmailQueryMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesNewGmailQuery>>>
    export type SourcesNewGmailQueryMutationBody = GmailQueryNew
    export type SourcesNewGmailQueryMutationError = AxiosError<Failure>

    export const useSourcesNewGmailQuery = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesNewGmailQuery>>, TError,{org: string;id: string;data: GmailQueryNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesNewGmailQuery>>, {org: string;id: string;data: GmailQueryNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesNewGmailQuery(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesNewGmailQuery>>, TError, {org: string;id: string;data: GmailQueryNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes a single gmail query by source by Id and query Id
 * @summary deletes gmail query by by source Id and query Id
 */
export const sourcesDeleteGmailQueries = (
    org: string,
    id: string,
    sourcesDeleteGmailQueriesBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/source/${id}/gmail`,{data:
      sourcesDeleteGmailQueriesBody, ...options}
    );
  }



    export type SourcesDeleteGmailQueriesMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteGmailQueries>>>
    export type SourcesDeleteGmailQueriesMutationBody = string[]
    export type SourcesDeleteGmailQueriesMutationError = AxiosError<Failure>

    export const useSourcesDeleteGmailQueries = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteGmailQueries>>, TError,{org: string;id: string;data: string[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteGmailQueries>>, {org: string;id: string;data: string[]}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesDeleteGmailQueries(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteGmailQueries>>, TError, {org: string;id: string;data: string[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a gmail query
 * @summary fetch a specific gmail filter
 */
export const sourcesGetGmailQuery = (
    org: string,
    id: string,
    queryId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GmailQuery>> => {
    return axios.get(
      `/api/v1/orgs/${org}/source/${id}/gmail-query/${queryId}`,options
    );
  }


export const getSourcesGetGmailQueryQueryKey = (org: string,
    id: string,
    queryId: string,) => [`/api/v1/orgs/${org}/source/${id}/gmail-query/${queryId}`];

    
export type SourcesGetGmailQueryQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetGmailQuery>>>
export type SourcesGetGmailQueryQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetGmailQuery = <TData = Awaited<ReturnType<typeof sourcesGetGmailQuery>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string,
    queryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetGmailQuery>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetGmailQueryQueryKey(org,id,queryId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetGmailQuery>>> = ({ signal }) => sourcesGetGmailQuery(org,id,queryId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetGmailQuery>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id && queryId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization user with the `org:w` scope to update a jira source.
 * @summary Update a gmail filter by id
 */
export const sourcesUpdateGmailQuery = (
    org: string,
    id: string,
    queryId: string,
    gmailQueryUpdate: GmailQueryUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GmailQuery>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/source/${id}/gmail-query/${queryId}`,
      gmailQueryUpdate,options
    );
  }



    export type SourcesUpdateGmailQueryMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateGmailQuery>>>
    export type SourcesUpdateGmailQueryMutationBody = GmailQueryUpdate
    export type SourcesUpdateGmailQueryMutationError = AxiosError<Failure>

    export const useSourcesUpdateGmailQuery = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateGmailQuery>>, TError,{org: string;id: string;queryId: string;data: GmailQueryUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateGmailQuery>>, {org: string;id: string;queryId: string;data: GmailQueryUpdate}> = (props) => {
          const {org,id,queryId,data} = props ?? {};

          return  sourcesUpdateGmailQuery(org,id,queryId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateGmailQuery>>, TError, {org: string;id: string;queryId: string;data: GmailQueryUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes a single gmail query by source by Id and query Id
 * @summary deletes gmail query by by source Id and query Id
 */
export const sourcesDeleteGmailQuery = (
    org: string,
    id: string,
    queryId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/source/${id}/gmail-query/${queryId}`,options
    );
  }



    export type SourcesDeleteGmailQueryMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteGmailQuery>>>
    
    export type SourcesDeleteGmailQueryMutationError = AxiosError<Failure>

    export const useSourcesDeleteGmailQuery = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteGmailQuery>>, TError,{org: string;id: string;queryId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteGmailQuery>>, {org: string;id: string;queryId: string}> = (props) => {
          const {org,id,queryId} = props ?? {};

          return  sourcesDeleteGmailQuery(org,id,queryId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteGmailQuery>>, TError, {org: string;id: string;queryId: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * preview gmail query response
 * @summary preview gmail query response
 */
export const sourcesGetGmailPreview = (
    org: string,
    id: string,
    gmailQueryNew: GmailQueryNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GmailEmailSummary[]>> => {
    return axios.post(
      `/api/v1/orgs/${org}/source/${id}/gmail-query-preview`,
      gmailQueryNew,options
    );
  }



    export type SourcesGetGmailPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesGetGmailPreview>>>
    export type SourcesGetGmailPreviewMutationBody = GmailQueryNew
    export type SourcesGetGmailPreviewMutationError = AxiosError<NotFoundResponse>

    export const useSourcesGetGmailPreview = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesGetGmailPreview>>, TError,{org: string;id: string;data: GmailQueryNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesGetGmailPreview>>, {org: string;id: string;data: GmailQueryNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesGetGmailPreview(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesGetGmailPreview>>, TError, {org: string;id: string;data: GmailQueryNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a list of calendars
 * @summary fetch a list of calendars for the user
 */
export const sourcesGetCalendars = (
    org: string,
    params?: SourcesGetCalendarsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceCalendar[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/source-calendars`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesGetCalendarsQueryKey = (org: string,
    params?: SourcesGetCalendarsParams,) => [`/api/v1/orgs/${org}/source-calendars`, ...(params ? [params]: [])];

    
export type SourcesGetCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetCalendars>>>
export type SourcesGetCalendarsQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetCalendars = <TData = Awaited<ReturnType<typeof sourcesGetCalendars>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    params?: SourcesGetCalendarsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetCalendars>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetCalendarsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetCalendars>>> = ({ signal }) => sourcesGetCalendars(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetCalendars>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Updates a document metadata (such as tags) by id.
 * @summary Update multiple calendars
 */
export const sourcesUpdateCalendars = (
    org: string,
    sourceCalendarUpdate: SourceCalendarUpdate[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceCalendar[]>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/source-calendars`,
      sourceCalendarUpdate,options
    );
  }



    export type SourcesUpdateCalendarsMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateCalendars>>>
    export type SourcesUpdateCalendarsMutationBody = SourceCalendarUpdate[]
    export type SourcesUpdateCalendarsMutationError = AxiosError<Failure>

    export const useSourcesUpdateCalendars = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateCalendars>>, TError,{org: string;data: SourceCalendarUpdate[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateCalendars>>, {org: string;data: SourceCalendarUpdate[]}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesUpdateCalendars(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateCalendars>>, TError, {org: string;data: SourceCalendarUpdate[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a list of documents
 * @summary get a single calendar for the user
 */
export const sourcesGetCalendar = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceCalendar>> => {
    return axios.get(
      `/api/v1/orgs/${org}/source-calendar/${id}`,options
    );
  }


export const getSourcesGetCalendarQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/source-calendar/${id}`];

    
export type SourcesGetCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetCalendar>>>
export type SourcesGetCalendarQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetCalendar = <TData = Awaited<ReturnType<typeof sourcesGetCalendar>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetCalendar>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetCalendarQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetCalendar>>> = ({ signal }) => sourcesGetCalendar(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetCalendar>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * deletes document metadata by Id (softly)
 * @summary deletes calendar metadata by Id (softly)
 */
export const sourcesDeleteCalendar = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/source-calendar/${id}`,options
    );
  }



    export type SourcesDeleteCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteCalendar>>>
    
    export type SourcesDeleteCalendarMutationError = AxiosError<Failure>

    export const useSourcesDeleteCalendar = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteCalendar>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteCalendar>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  sourcesDeleteCalendar(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteCalendar>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a list of documents
 * @summary fetch a list of documents for the user
 */
export const sourcesGetDocuments = (
    org: string,
    params?: SourcesGetDocumentsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceDocument[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/source-documents`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesGetDocumentsQueryKey = (org: string,
    params?: SourcesGetDocumentsParams,) => [`/api/v1/orgs/${org}/source-documents`, ...(params ? [params]: [])];

    
export type SourcesGetDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetDocuments>>>
export type SourcesGetDocumentsQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetDocuments = <TData = Awaited<ReturnType<typeof sourcesGetDocuments>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    params?: SourcesGetDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetDocuments>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetDocumentsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetDocuments>>> = ({ signal }) => sourcesGetDocuments(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetDocuments>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables the user to upload a link to a new document
 * @summary Create new document
 */
export const sourcesNewDocument = (
    org: string,
    sourceDocumentNew: SourceDocumentNew[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceDocument[]>> => {
    return axios.post(
      `/api/v1/orgs/${org}/source-documents`,
      sourceDocumentNew,options
    );
  }



    export type SourcesNewDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesNewDocument>>>
    export type SourcesNewDocumentMutationBody = SourceDocumentNew[]
    export type SourcesNewDocumentMutationError = AxiosError<Failure>

    export const useSourcesNewDocument = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesNewDocument>>, TError,{org: string;data: SourceDocumentNew[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesNewDocument>>, {org: string;data: SourceDocumentNew[]}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesNewDocument(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesNewDocument>>, TError, {org: string;data: SourceDocumentNew[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Updates a document metadata (such as tags) by id.
 * @summary Update multiple documents
 */
export const sourcesUpdateDocuments = (
    org: string,
    sourceDocumentUpdate: SourceDocumentUpdate[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceDocument[]>> => {
    return axios.put(
      `/api/v1/orgs/${org}/source-documents`,
      sourceDocumentUpdate,options
    );
  }



    export type SourcesUpdateDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateDocuments>>>
    export type SourcesUpdateDocumentsMutationBody = SourceDocumentUpdate[]
    export type SourcesUpdateDocumentsMutationError = AxiosError<Failure>

    export const useSourcesUpdateDocuments = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateDocuments>>, TError,{org: string;data: SourceDocumentUpdate[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateDocuments>>, {org: string;data: SourceDocumentUpdate[]}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesUpdateDocuments(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateDocuments>>, TError, {org: string;data: SourceDocumentUpdate[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update search scope on user notes
 * @summary Update search scope on user notes
 */
export const twinsUpdateDocumentsScope = (
    org: string,
    searchScopeUpdate: SearchScopeUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/source-documents`,
      searchScopeUpdate,options
    );
  }



    export type TwinsUpdateDocumentsScopeMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdateDocumentsScope>>>
    export type TwinsUpdateDocumentsScopeMutationBody = SearchScopeUpdate
    export type TwinsUpdateDocumentsScopeMutationError = AxiosError<Failure>

    export const useTwinsUpdateDocumentsScope = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdateDocumentsScope>>, TError,{org: string;data: SearchScopeUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdateDocumentsScope>>, {org: string;data: SearchScopeUpdate}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsUpdateDocumentsScope(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdateDocumentsScope>>, TError, {org: string;data: SearchScopeUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes document metadata by Id (softly)
 * @summary builk deletes documents metadata by Id (softly)
 */
export const sourcesDeleteDocuments = (
    org: string,
    sourcesDeleteDocumentsBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/source-documents`,{data:
      sourcesDeleteDocumentsBody, ...options}
    );
  }



    export type SourcesDeleteDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteDocuments>>>
    export type SourcesDeleteDocumentsMutationBody = string[]
    export type SourcesDeleteDocumentsMutationError = AxiosError<Failure>

    export const useSourcesDeleteDocuments = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteDocuments>>, TError,{org: string;data: string[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteDocuments>>, {org: string;data: string[]}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesDeleteDocuments(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteDocuments>>, TError, {org: string;data: string[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a list of documents
 * @summary get a single document for the user
 */
export const sourcesGetDocument = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceDocument>> => {
    return axios.get(
      `/api/v1/orgs/${org}/source-document/${id}`,options
    );
  }


export const getSourcesGetDocumentQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/source-document/${id}`];

    
export type SourcesGetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetDocument>>>
export type SourcesGetDocumentQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetDocument = <TData = Awaited<ReturnType<typeof sourcesGetDocument>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetDocument>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetDocumentQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetDocument>>> = ({ signal }) => sourcesGetDocument(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetDocument>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * deletes document metadata by Id (softly)
 * @summary deletes document metadata by Id (softly)
 */
export const sourcesDeleteDocument = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/source-document/${id}`,options
    );
  }



    export type SourcesDeleteDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteDocument>>>
    
    export type SourcesDeleteDocumentMutationError = AxiosError<Failure>

    export const useSourcesDeleteDocument = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteDocument>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteDocument>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  sourcesDeleteDocument(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteDocument>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * list jira sources for the authenticated org
 * @summary list jira sources for the authenticated org
 */
export const sourcesListJira = (
    org: string,
    params?: SourcesListJiraParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Jira[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/jira`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesListJiraQueryKey = (org: string,
    params?: SourcesListJiraParams,) => [`/api/v1/orgs/${org}/jira`, ...(params ? [params]: [])];

    
export type SourcesListJiraQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesListJira>>>
export type SourcesListJiraQueryError = AxiosError<Failure>

export const useSourcesListJira = <TData = Awaited<ReturnType<typeof sourcesListJira>>, TError = AxiosError<Failure>>(
 org: string,
    params?: SourcesListJiraParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesListJira>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesListJiraQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesListJira>>> = ({ signal }) => sourcesListJira(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesListJira>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a source for the authenticated user and the org.
 * @summary create a jira source for the authenticated user
 */
export const sourcesCreateJira = (
    org: string,
    jiraNew: JiraNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Jira>> => {
    return axios.post(
      `/api/v1/orgs/${org}/jira`,
      jiraNew,options
    );
  }



    export type SourcesCreateJiraMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesCreateJira>>>
    export type SourcesCreateJiraMutationBody = JiraNew
    export type SourcesCreateJiraMutationError = AxiosError<Failure>

    export const useSourcesCreateJira = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesCreateJira>>, TError,{org: string;data: JiraNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesCreateJira>>, {org: string;data: JiraNew}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesCreateJira(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesCreateJira>>, TError, {org: string;data: JiraNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get jira labels for a potential source
 * @summary Get jira labels for a potential source
 */
export const sourcesJiraListLabels = (
    org: string,
    jiraConnection: JiraConnection, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.post(
      `/api/v1/orgs/${org}/jira/labels`,
      jiraConnection,options
    );
  }



    export type SourcesJiraListLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesJiraListLabels>>>
    export type SourcesJiraListLabelsMutationBody = JiraConnection
    export type SourcesJiraListLabelsMutationError = AxiosError<NotFoundResponse>

    export const useSourcesJiraListLabels = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesJiraListLabels>>, TError,{org: string;data: JiraConnection}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesJiraListLabels>>, {org: string;data: JiraConnection}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesJiraListLabels(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesJiraListLabels>>, TError, {org: string;data: JiraConnection}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get jira projects for a potential source
 * @summary Get jira projects for a potential source
 */
export const sourcesJiraListProjects = (
    org: string,
    jiraConnection: JiraConnection, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JiraProject[]>> => {
    return axios.post(
      `/api/v1/orgs/${org}/jira/projects`,
      jiraConnection,options
    );
  }



    export type SourcesJiraListProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesJiraListProjects>>>
    export type SourcesJiraListProjectsMutationBody = JiraConnection
    export type SourcesJiraListProjectsMutationError = AxiosError<NotFoundResponse>

    export const useSourcesJiraListProjects = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesJiraListProjects>>, TError,{org: string;data: JiraConnection}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesJiraListProjects>>, {org: string;data: JiraConnection}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesJiraListProjects(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesJiraListProjects>>, TError, {org: string;data: JiraConnection}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get jira statuses for a potential source
 * @summary Get jira statuses for a potential source
 */
export const sourcesJiraListStatuses = (
    org: string,
    jiraConnection: JiraConnection, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.post(
      `/api/v1/orgs/${org}/jira/statuses`,
      jiraConnection,options
    );
  }



    export type SourcesJiraListStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesJiraListStatuses>>>
    export type SourcesJiraListStatusesMutationBody = JiraConnection
    export type SourcesJiraListStatusesMutationError = AxiosError<NotFoundResponse>

    export const useSourcesJiraListStatuses = <TError = AxiosError<NotFoundResponse>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesJiraListStatuses>>, TError,{org: string;data: JiraConnection}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesJiraListStatuses>>, {org: string;data: JiraConnection}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesJiraListStatuses(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesJiraListStatuses>>, TError, {org: string;data: JiraConnection}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a jira source
 * @summary fetch a jira source
 */
export const sourcesGetJira = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Jira>> => {
    return axios.get(
      `/api/v1/orgs/${org}/jira/${id}`,options
    );
  }


export const getSourcesGetJiraQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/jira/${id}`];

    
export type SourcesGetJiraQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetJira>>>
export type SourcesGetJiraQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetJira = <TData = Awaited<ReturnType<typeof sourcesGetJira>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetJira>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetJiraQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetJira>>> = ({ signal }) => sourcesGetJira(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetJira>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization user with the `org:w` scope to update a jira source.
 * @summary Update a jira source
 */
export const sourcesUpdateJira = (
    org: string,
    id: string,
    jiraUpdate: JiraUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Jira>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/jira/${id}`,
      jiraUpdate,options
    );
  }



    export type SourcesUpdateJiraMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateJira>>>
    export type SourcesUpdateJiraMutationBody = JiraUpdate
    export type SourcesUpdateJiraMutationError = AxiosError<Failure>

    export const useSourcesUpdateJira = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateJira>>, TError,{org: string;id: string;data: JiraUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateJira>>, {org: string;id: string;data: JiraUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesUpdateJira(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateJira>>, TError, {org: string;id: string;data: JiraUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes a single jira source by Id
 * @summary deletes jira source by Id
 */
export const sourcesDeleteJira = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/jira/${id}`,options
    );
  }



    export type SourcesDeleteJiraMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteJira>>>
    
    export type SourcesDeleteJiraMutationError = AxiosError<Failure>

    export const useSourcesDeleteJira = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteJira>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteJira>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  sourcesDeleteJira(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteJira>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get a list of jira epics (unresolved) for a source
 * @summary Get jira epics for a source
 */
export const sourcesJiraListEpics = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<JiraEpic[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/jira/${id}/epics`,options
    );
  }


export const getSourcesJiraListEpicsQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/jira/${id}/epics`];

    
export type SourcesJiraListEpicsQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesJiraListEpics>>>
export type SourcesJiraListEpicsQueryError = AxiosError<NotFoundResponse>

export const useSourcesJiraListEpics = <TData = Awaited<ReturnType<typeof sourcesJiraListEpics>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesJiraListEpics>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesJiraListEpicsQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesJiraListEpics>>> = ({ signal }) => sourcesJiraListEpics(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesJiraListEpics>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * validate jira source by id
 * @summary validate jira source by id
 */
export const sourcesValidateJiraById = (
    org: string,
    params: SourcesValidateJiraByIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceValidate>> => {
    return axios.get(
      `/api/v1/orgs/${org}/jira/validate`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesValidateJiraByIdQueryKey = (org: string,
    params: SourcesValidateJiraByIdParams,) => [`/api/v1/orgs/${org}/jira/validate`, ...(params ? [params]: [])];

    
export type SourcesValidateJiraByIdQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesValidateJiraById>>>
export type SourcesValidateJiraByIdQueryError = AxiosError<Failure>

export const useSourcesValidateJiraById = <TData = Awaited<ReturnType<typeof sourcesValidateJiraById>>, TError = AxiosError<Failure>>(
 org: string,
    params: SourcesValidateJiraByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesValidateJiraById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesValidateJiraByIdQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesValidateJiraById>>> = ({ signal }) => sourcesValidateJiraById(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesValidateJiraById>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * validate jira source
 * @summary validate jira source
 */
export const sourcesValidateJira = (
    org: string,
    jiraConnection: JiraConnection, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceValidate>> => {
    return axios.post(
      `/api/v1/orgs/${org}/jira/validate`,
      jiraConnection,options
    );
  }



    export type SourcesValidateJiraMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesValidateJira>>>
    export type SourcesValidateJiraMutationBody = JiraConnection
    export type SourcesValidateJiraMutationError = AxiosError<Failure>

    export const useSourcesValidateJira = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesValidateJira>>, TError,{org: string;data: JiraConnection}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesValidateJira>>, {org: string;data: JiraConnection}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesValidateJira(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesValidateJira>>, TError, {org: string;data: JiraConnection}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * validate salesforce source by id
 * @summary validate salesforce source by id
 */
export const sourcesValidateSalesforceById = (
    org: string,
    params: SourcesValidateSalesforceByIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceValidate>> => {
    return axios.get(
      `/api/v1/orgs/${org}/salesforce/validate`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesValidateSalesforceByIdQueryKey = (org: string,
    params: SourcesValidateSalesforceByIdParams,) => [`/api/v1/orgs/${org}/salesforce/validate`, ...(params ? [params]: [])];

    
export type SourcesValidateSalesforceByIdQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesValidateSalesforceById>>>
export type SourcesValidateSalesforceByIdQueryError = AxiosError<Failure>

export const useSourcesValidateSalesforceById = <TData = Awaited<ReturnType<typeof sourcesValidateSalesforceById>>, TError = AxiosError<Failure>>(
 org: string,
    params: SourcesValidateSalesforceByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesValidateSalesforceById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesValidateSalesforceByIdQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesValidateSalesforceById>>> = ({ signal }) => sourcesValidateSalesforceById(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesValidateSalesforceById>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * validate salesforce source
 * @summary validate salesforce source
 */
export const sourcesValidateSalesforce = (
    org: string,
    salesforceConnection: SalesforceConnection, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceValidate>> => {
    return axios.post(
      `/api/v1/orgs/${org}/salesforce/validate`,
      salesforceConnection,options
    );
  }



    export type SourcesValidateSalesforceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesValidateSalesforce>>>
    export type SourcesValidateSalesforceMutationBody = SalesforceConnection
    export type SourcesValidateSalesforceMutationError = AxiosError<Failure>

    export const useSourcesValidateSalesforce = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesValidateSalesforce>>, TError,{org: string;data: SalesforceConnection}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesValidateSalesforce>>, {org: string;data: SalesforceConnection}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesValidateSalesforce(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesValidateSalesforce>>, TError, {org: string;data: SalesforceConnection}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * list salesforce sources for the authenticated org
 * @summary list salesforce sources for the authenticated org
 */
export const sourcesListSalesforce = (
    org: string,
    params?: SourcesListSalesforceParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Salesforce[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/salesforce`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSourcesListSalesforceQueryKey = (org: string,
    params?: SourcesListSalesforceParams,) => [`/api/v1/orgs/${org}/salesforce`, ...(params ? [params]: [])];

    
export type SourcesListSalesforceQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesListSalesforce>>>
export type SourcesListSalesforceQueryError = AxiosError<Failure>

export const useSourcesListSalesforce = <TData = Awaited<ReturnType<typeof sourcesListSalesforce>>, TError = AxiosError<Failure>>(
 org: string,
    params?: SourcesListSalesforceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesListSalesforce>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesListSalesforceQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesListSalesforce>>> = ({ signal }) => sourcesListSalesforce(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesListSalesforce>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a source for the authenticated user and the org.
 * @summary create a salesforce source for the authenticated user
 */
export const sourcesCreateSalesforce = (
    org: string,
    salesforceNew: SalesforceNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Salesforce>> => {
    return axios.post(
      `/api/v1/orgs/${org}/salesforce`,
      salesforceNew,options
    );
  }



    export type SourcesCreateSalesforceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesCreateSalesforce>>>
    export type SourcesCreateSalesforceMutationBody = SalesforceNew
    export type SourcesCreateSalesforceMutationError = AxiosError<Failure>

    export const useSourcesCreateSalesforce = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesCreateSalesforce>>, TError,{org: string;data: SalesforceNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesCreateSalesforce>>, {org: string;data: SalesforceNew}> = (props) => {
          const {org,data} = props ?? {};

          return  sourcesCreateSalesforce(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesCreateSalesforce>>, TError, {org: string;data: SalesforceNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * fetch a salesforce source
 * @summary fetch a salesforce source
 */
export const sourcesGetSalesforce = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Salesforce>> => {
    return axios.get(
      `/api/v1/orgs/${org}/salesforce/${id}`,options
    );
  }


export const getSourcesGetSalesforceQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/salesforce/${id}`];

    
export type SourcesGetSalesforceQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGetSalesforce>>>
export type SourcesGetSalesforceQueryError = AxiosError<NotFoundResponse>

export const useSourcesGetSalesforce = <TData = Awaited<ReturnType<typeof sourcesGetSalesforce>>, TError = AxiosError<NotFoundResponse>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGetSalesforce>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSourcesGetSalesforceQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGetSalesforce>>> = ({ signal }) => sourcesGetSalesforce(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof sourcesGetSalesforce>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization user with the `org:w` scope to update a salesforce source.
 * @summary Update a salesforce source
 */
export const sourcesUpdateSalesforce = (
    org: string,
    id: string,
    salesforceUpdate: SalesforceUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Salesforce>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/salesforce/${id}`,
      salesforceUpdate,options
    );
  }



    export type SourcesUpdateSalesforceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesUpdateSalesforce>>>
    export type SourcesUpdateSalesforceMutationBody = SalesforceUpdate
    export type SourcesUpdateSalesforceMutationError = AxiosError<Failure>

    export const useSourcesUpdateSalesforce = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesUpdateSalesforce>>, TError,{org: string;id: string;data: SalesforceUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesUpdateSalesforce>>, {org: string;id: string;data: SalesforceUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  sourcesUpdateSalesforce(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesUpdateSalesforce>>, TError, {org: string;id: string;data: SalesforceUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes a single salesforce source by Id
 * @summary deletes salesforce source by Id
 */
export const sourcesDeleteSalesforce = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/salesforce/${id}`,options
    );
  }



    export type SourcesDeleteSalesforceMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesDeleteSalesforce>>>
    
    export type SourcesDeleteSalesforceMutationError = AxiosError<Failure>

    export const useSourcesDeleteSalesforce = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesDeleteSalesforce>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesDeleteSalesforce>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  sourcesDeleteSalesforce(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof sourcesDeleteSalesforce>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * create subscription
 * @summary create subscription
 */
export const subscriptionsCreate = (
    org: string,
    subscriptionNew: SubscriptionNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Subscription>> => {
    return axios.post(
      `/api/v1/orgs/${org}/subscriptions`,
      subscriptionNew,options
    );
  }



    export type SubscriptionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof subscriptionsCreate>>>
    export type SubscriptionsCreateMutationBody = SubscriptionNew
    export type SubscriptionsCreateMutationError = AxiosError<Failure>

    export const useSubscriptionsCreate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscriptionsCreate>>, TError,{org: string;data: SubscriptionNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscriptionsCreate>>, {org: string;data: SubscriptionNew}> = (props) => {
          const {org,data} = props ?? {};

          return  subscriptionsCreate(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof subscriptionsCreate>>, TError, {org: string;data: SubscriptionNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Return all teams up to a specified limit based on searchable parameters

 * @summary Returns teams based on query
 */
export const teams = (
    org: string,
    params?: TeamsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Team[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/teams`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTeamsQueryKey = (org: string,
    params?: TeamsParams,) => [`/api/v1/orgs/${org}/teams`, ...(params ? [params]: [])];

    
export type TeamsQueryResult = NonNullable<Awaited<ReturnType<typeof teams>>>
export type TeamsQueryError = AxiosError<Failure>

export const useTeams = <TData = Awaited<ReturnType<typeof teams>>, TError = AxiosError<Failure>>(
 org: string,
    params?: TeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teams>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof teams>>> = ({ signal }) => teams(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof teams>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * creates new team
 * @summary create new team
 */
export const _new = (
    org: string,
    teamNew: TeamNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Team>> => {
    return axios.post(
      `/api/v1/orgs/${org}/teams`,
      teamNew,options
    );
  }



    export type NewMutationResult = NonNullable<Awaited<ReturnType<typeof _new>>>
    export type NewMutationBody = TeamNew
    export type NewMutationError = AxiosError<Failure>

    export const useNew = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _new>>, TError,{org: string;data: TeamNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _new>>, {org: string;data: TeamNew}> = (props) => {
          const {org,data} = props ?? {};

          return  _new(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof _new>>, TError, {org: string;data: TeamNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a team by single id
 * @summary Returns a team by Id
 */
export const team = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Team | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/teams/${id}`,options
    );
  }


export const getTeamQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/teams/${id}`];

    
export type TeamQueryResult = NonNullable<Awaited<ReturnType<typeof team>>>
export type TeamQueryError = AxiosError<Failure>

export const useTeam = <TData = Awaited<ReturnType<typeof team>>, TError = AxiosError<Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof team>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof team>>> = ({ signal }) => team(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof team>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * deletes a single team by Id
 * @summary deletes team by Id
 */
export const _delete = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/teams/${id}`,options
    );
  }



    export type DeleteMutationResult = NonNullable<Awaited<ReturnType<typeof _delete>>>
    
    export type DeleteMutationError = AxiosError<Failure>

    export const useDelete = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _delete>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _delete>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  _delete(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof _delete>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update a team by id
 * @summary Update a team
 */
export const update = (
    org: string,
    id: string,
    teamUpdate: TeamUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Team>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/teams/${id}`,
      teamUpdate,options
    );
  }



    export type UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof update>>>
    export type UpdateMutationBody = TeamUpdate
    export type UpdateMutationError = AxiosError<Failure>

    export const useUpdate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{org: string;id: string;data: TeamUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update>>, {org: string;id: string;data: TeamUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  update(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof update>>, TError, {org: string;id: string;data: TeamUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * adds employees to a team
 * @summary add or update a team member
 */
export const addTeamMember = (
    org: string,
    id: string,
    teamMembership: TeamMembership, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TeamMember>> => {
    return axios.put(
      `/api/v1/orgs/${org}/teams/${id}/member`,
      teamMembership,options
    );
  }



    export type AddTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof addTeamMember>>>
    export type AddTeamMemberMutationBody = TeamMembership
    export type AddTeamMemberMutationError = AxiosError<TeamMembership>

    export const useAddTeamMember = <TError = AxiosError<TeamMembership>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTeamMember>>, TError,{org: string;id: string;data: TeamMembership}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTeamMember>>, {org: string;id: string;data: TeamMembership}> = (props) => {
          const {org,id,data} = props ?? {};

          return  addTeamMember(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof addTeamMember>>, TError, {org: string;id: string;data: TeamMembership}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes team members form the team by Id
 * @summary deletes team members by team Id
 */
export const deleteTeamMember = (
    org: string,
    id: string,
    params: DeleteTeamMemberParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/teams/${id}/member`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type DeleteTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamMember>>>
    
    export type DeleteTeamMemberMutationError = AxiosError<Failure>

    export const useDeleteTeamMember = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMember>>, TError,{org: string;id: string;params: DeleteTeamMemberParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamMember>>, {org: string;id: string;params: DeleteTeamMemberParams}> = (props) => {
          const {org,id,params} = props ?? {};

          return  deleteTeamMember(org,id,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof deleteTeamMember>>, TError, {org: string;id: string;params: DeleteTeamMemberParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a list of direct members of the team by team Id
 * @summary Returns a list of direct memebers of the team
 */
export const teamMembers = (
    org: string,
    id: string,
    params?: TeamMembersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TeamMember[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/teams/${id}/members`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTeamMembersQueryKey = (org: string,
    id: string,
    params?: TeamMembersParams,) => [`/api/v1/orgs/${org}/teams/${id}/members`, ...(params ? [params]: [])];

    
export type TeamMembersQueryResult = NonNullable<Awaited<ReturnType<typeof teamMembers>>>
export type TeamMembersQueryError = AxiosError<void | Failure>

export const useTeamMembers = <TData = Awaited<ReturnType<typeof teamMembers>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string,
    params?: TeamMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamMembers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTeamMembersQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof teamMembers>>> = ({ signal }) => teamMembers(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof teamMembers>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a twin by signle twin id
 * @summary Returns a twin by user Id
 */
export const usersTwinsGet = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin>> => {
    return axios.get(
      `/api/v1/orgs/${org}/users/twins/${id}`,options
    );
  }


export const getUsersTwinsGetQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/users/twins/${id}`];

    
export type UsersTwinsGetQueryResult = NonNullable<Awaited<ReturnType<typeof usersTwinsGet>>>
export type UsersTwinsGetQueryError = AxiosError<void | Failure>

export const useUsersTwinsGet = <TData = Awaited<ReturnType<typeof usersTwinsGet>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersTwinsGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersTwinsGetQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersTwinsGet>>> = ({ signal }) => usersTwinsGet(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersTwinsGet>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Get a single insight category by id
 * @summary Get insight category
 */
export const twinsGetInsightCategory = (
    org: string,
    id: string,
    categoryId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInsightCategory>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/insight-category/${categoryId}`,options
    );
  }


export const getTwinsGetInsightCategoryQueryKey = (org: string,
    id: string,
    categoryId: string,) => [`/api/v1/orgs/${org}/twins/${id}/insight-category/${categoryId}`];

    
export type TwinsGetInsightCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetInsightCategory>>>
export type TwinsGetInsightCategoryQueryError = AxiosError<unknown>

export const useTwinsGetInsightCategory = <TData = Awaited<ReturnType<typeof twinsGetInsightCategory>>, TError = AxiosError<unknown>>(
 org: string,
    id: string,
    categoryId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetInsightCategory>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetInsightCategoryQueryKey(org,id,categoryId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetInsightCategory>>> = ({ signal }) => twinsGetInsightCategory(org,id,categoryId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetInsightCategory>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id && categoryId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables the user to update an insight category by id
 * @summary Update insight category
 */
export const twinsUpdateInsightCategory = (
    org: string,
    id: string,
    categoryId: string,
    twinInsightCategoryUpdate: TwinInsightCategoryUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInsightCategory>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twins/${id}/insight-category/${categoryId}`,
      twinInsightCategoryUpdate,options
    );
  }



    export type TwinsUpdateInsightCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdateInsightCategory>>>
    export type TwinsUpdateInsightCategoryMutationBody = TwinInsightCategoryUpdate
    export type TwinsUpdateInsightCategoryMutationError = AxiosError<unknown>

    export const useTwinsUpdateInsightCategory = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdateInsightCategory>>, TError,{org: string;id: string;categoryId: string;data: TwinInsightCategoryUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdateInsightCategory>>, {org: string;id: string;categoryId: string;data: TwinInsightCategoryUpdate}> = (props) => {
          const {org,id,categoryId,data} = props ?? {};

          return  twinsUpdateInsightCategory(org,id,categoryId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdateInsightCategory>>, TError, {org: string;id: string;categoryId: string;data: TwinInsightCategoryUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Enables the user to delete an insight category by id
 * @summary Delete insight category
 */
export const twinsDeleteInsightCategory = (
    org: string,
    id: string,
    categoryId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twins/${id}/insight-category/${categoryId}`,options
    );
  }



    export type TwinsDeleteInsightCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeleteInsightCategory>>>
    
    export type TwinsDeleteInsightCategoryMutationError = AxiosError<unknown>

    export const useTwinsDeleteInsightCategory = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeleteInsightCategory>>, TError,{org: string;id: string;categoryId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeleteInsightCategory>>, {org: string;id: string;categoryId: string}> = (props) => {
          const {org,id,categoryId} = props ?? {};

          return  twinsDeleteInsightCategory(org,id,categoryId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeleteInsightCategory>>, TError, {org: string;id: string;categoryId: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List insights categories
 * @summary List insights
 */
export const twinsListInsightCategories = (
    org: string,
    id: string,
    params?: TwinsListInsightCategoriesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInsightCategory[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/insight-categories`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsListInsightCategoriesQueryKey = (org: string,
    id: string,
    params?: TwinsListInsightCategoriesParams,) => [`/api/v1/orgs/${org}/twins/${id}/insight-categories`, ...(params ? [params]: [])];

    
export type TwinsListInsightCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof twinsListInsightCategories>>>
export type TwinsListInsightCategoriesQueryError = AxiosError<unknown>

export const useTwinsListInsightCategories = <TData = Awaited<ReturnType<typeof twinsListInsightCategories>>, TError = AxiosError<unknown>>(
 org: string,
    id: string,
    params?: TwinsListInsightCategoriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsListInsightCategories>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsListInsightCategoriesQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsListInsightCategories>>> = ({ signal }) => twinsListInsightCategories(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsListInsightCategories>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables the user to create a new insight category
 * @summary Create new insight categories in bulk
 */
export const twinsNewInsightCategories = (
    org: string,
    id: string,
    twinInsightCategoryNew: TwinInsightCategoryNew[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInsightCategory[]>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/insight-categories`,
      twinInsightCategoryNew,options
    );
  }



    export type TwinsNewInsightCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof twinsNewInsightCategories>>>
    export type TwinsNewInsightCategoriesMutationBody = TwinInsightCategoryNew[]
    export type TwinsNewInsightCategoriesMutationError = AxiosError<unknown>

    export const useTwinsNewInsightCategories = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsNewInsightCategories>>, TError,{org: string;id: string;data: TwinInsightCategoryNew[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsNewInsightCategories>>, {org: string;id: string;data: TwinInsightCategoryNew[]}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsNewInsightCategories(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsNewInsightCategories>>, TError, {org: string;id: string;data: TwinInsightCategoryNew[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Enables the user to update multiple insight categories in a batch
 * @summary Update multiple insight categories in bulk
 */
export const twinsUpdateInsightCategories = (
    org: string,
    id: string,
    twinInsightCategoryUpdate: TwinInsightCategoryUpdate[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInsightCategory[]>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twins/${id}/insight-categories`,
      twinInsightCategoryUpdate,options
    );
  }



    export type TwinsUpdateInsightCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdateInsightCategories>>>
    export type TwinsUpdateInsightCategoriesMutationBody = TwinInsightCategoryUpdate[]
    export type TwinsUpdateInsightCategoriesMutationError = AxiosError<unknown>

    export const useTwinsUpdateInsightCategories = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdateInsightCategories>>, TError,{org: string;id: string;data: TwinInsightCategoryUpdate[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdateInsightCategories>>, {org: string;id: string;data: TwinInsightCategoryUpdate[]}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsUpdateInsightCategories(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdateInsightCategories>>, TError, {org: string;id: string;data: TwinInsightCategoryUpdate[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Enables the user to delete insight categories
 * @summary Delete insight categories
 */
export const twinsDeleteInsightCategories = (
    org: string,
    id: string,
    twinsDeleteInsightCategoriesBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twins/${id}/insight-categories`,{data:
      twinsDeleteInsightCategoriesBody, ...options}
    );
  }



    export type TwinsDeleteInsightCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeleteInsightCategories>>>
    export type TwinsDeleteInsightCategoriesMutationBody = string[]
    export type TwinsDeleteInsightCategoriesMutationError = AxiosError<unknown>

    export const useTwinsDeleteInsightCategories = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeleteInsightCategories>>, TError,{org: string;id: string;data: string[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeleteInsightCategories>>, {org: string;id: string;data: string[]}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsDeleteInsightCategories(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeleteInsightCategories>>, TError, {org: string;id: string;data: string[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get suggested categories
 * @summary Get suggested categories
 */
export const twinsGetSuggestedCategories = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/suggested-insight-categories`,options
    );
  }


export const getTwinsGetSuggestedCategoriesQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twins/${id}/suggested-insight-categories`];

    
export type TwinsGetSuggestedCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetSuggestedCategories>>>
export type TwinsGetSuggestedCategoriesQueryError = AxiosError<unknown>

export const useTwinsGetSuggestedCategories = <TData = Awaited<ReturnType<typeof twinsGetSuggestedCategories>>, TError = AxiosError<unknown>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetSuggestedCategories>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetSuggestedCategoriesQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetSuggestedCategories>>> = ({ signal }) => twinsGetSuggestedCategories(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetSuggestedCategories>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Return dashboard data for a twin
 * @summary Return dashboard data for a twin
 */
export const twinsGetDashboard = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinDashboard>> => {
    return axios.get(
      `/api/v1/orgs/${org}/users/twins/${id}/dashboard`,options
    );
  }


export const getTwinsGetDashboardQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/users/twins/${id}/dashboard`];

    
export type TwinsGetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetDashboard>>>
export type TwinsGetDashboardQueryError = AxiosError<unknown>

export const useTwinsGetDashboard = <TData = Awaited<ReturnType<typeof twinsGetDashboard>>, TError = AxiosError<unknown>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetDashboard>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetDashboardQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetDashboard>>> = ({ signal }) => twinsGetDashboard(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetDashboard>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a twin by signle twin id
 * @summary Returns a twin by Id
 */
export const twinsGet = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}`,options
    );
  }


export const getTwinsGetQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twins/${id}`];

    
export type TwinsGetQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGet>>>
export type TwinsGetQueryError = AxiosError<void | Failure>

export const useTwinsGet = <TData = Awaited<ReturnType<typeof twinsGet>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGet>>> = ({ signal }) => twinsGet(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGet>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization owner with the `org:w` scope to update the employee's profile.
 * @summary Update a twin
 */
export const twinsUpdate = (
    org: string,
    id: string,
    twinUpdate: TwinUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twins/${id}`,
      twinUpdate,options
    );
  }



    export type TwinsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdate>>>
    export type TwinsUpdateMutationBody = TwinUpdate
    export type TwinsUpdateMutationError = AxiosError<Failure>

    export const useTwinsUpdate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdate>>, TError,{org: string;id: string;data: TwinUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdate>>, {org: string;id: string;data: TwinUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsUpdate(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdate>>, TError, {org: string;id: string;data: TwinUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Return all twins up to a specified limit based on searchable parameters

 * @summary Returns twins based on query
 */
export const twinsGetMultiple = (
    org: string,
    params?: TwinsGetMultipleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsGetMultipleQueryKey = (org: string,
    params?: TwinsGetMultipleParams,) => [`/api/v1/orgs/${org}/twins`, ...(params ? [params]: [])];

    
export type TwinsGetMultipleQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetMultiple>>>
export type TwinsGetMultipleQueryError = AxiosError<Failure>

export const useTwinsGetMultiple = <TData = Awaited<ReturnType<typeof twinsGetMultiple>>, TError = AxiosError<Failure>>(
 org: string,
    params?: TwinsGetMultipleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetMultiple>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetMultipleQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetMultiple>>> = ({ signal }) => twinsGetMultiple(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetMultiple>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * upload a photo for the twin
 * @summary upload a photo for the twin
 */
export const twinsUploadPicture = (
    org: string,
    id: string,
    twinsUploadPictureBody: Blob, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Picture>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/picture`,
      twinsUploadPictureBody,options
    );
  }



    export type TwinsUploadPictureMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUploadPicture>>>
    export type TwinsUploadPictureMutationBody = Blob
    export type TwinsUploadPictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsUploadPicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUploadPicture>>, TError,{org: string;id: string;data: Blob}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUploadPicture>>, {org: string;id: string;data: Blob}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsUploadPicture(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUploadPicture>>, TError, {org: string;id: string;data: Blob}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete a picture for the twins
 * @summary delete twins picture
 */
export const twinsDeletePicture = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twins/${id}/picture`,options
    );
  }



    export type TwinsDeletePictureMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeletePicture>>>
    
    export type TwinsDeletePictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsDeletePicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeletePicture>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeletePicture>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  twinsDeletePicture(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeletePicture>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Return all twins up to a specified limit based on searchable parameters

 * @summary Returns twins based on query
 */
export const twinsGetSharedWith = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/share`,options
    );
  }


export const getTwinsGetSharedWithQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twins/${id}/share`];

    
export type TwinsGetSharedWithQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetSharedWith>>>
export type TwinsGetSharedWithQueryError = AxiosError<Failure>

export const useTwinsGetSharedWith = <TData = Awaited<ReturnType<typeof twinsGetSharedWith>>, TError = AxiosError<Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetSharedWith>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetSharedWithQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetSharedWith>>> = ({ signal }) => twinsGetSharedWith(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetSharedWith>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a unique share link for a twin
 * @summary Returns a unique share link for a twin
 */
export const twinsShare = (
    org: string,
    id: string,
    twinShareNew: TwinShareNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinShare>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/share`,
      twinShareNew,options
    );
  }



    export type TwinsShareMutationResult = NonNullable<Awaited<ReturnType<typeof twinsShare>>>
    export type TwinsShareMutationBody = TwinShareNew
    export type TwinsShareMutationError = AxiosError<void | Failure>

    export const useTwinsShare = <TError = AxiosError<void | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsShare>>, TError,{org: string;id: string;data: TwinShareNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsShare>>, {org: string;id: string;data: TwinShareNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsShare(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsShare>>, TError, {org: string;id: string;data: TwinShareNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a twin after successfully accepting the share
 * @summary Returns a twin after successfully accepting the share
 */
export const twinsAcceptShare = (
    org: string,
    id: string,
    params: TwinsAcceptShareParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twins/${id}/share`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsAcceptShareMutationResult = NonNullable<Awaited<ReturnType<typeof twinsAcceptShare>>>
    
    export type TwinsAcceptShareMutationError = AxiosError<void | Failure>

    export const useTwinsAcceptShare = <TError = AxiosError<void | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsAcceptShare>>, TError,{org: string;id: string;params: TwinsAcceptShareParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsAcceptShare>>, {org: string;id: string;params: TwinsAcceptShareParams}> = (props) => {
          const {org,id,params} = props ?? {};

          return  twinsAcceptShare(org,id,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsAcceptShare>>, TError, {org: string;id: string;params: TwinsAcceptShareParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * @summary Returns a list of skills for a twin
 */
export const twinsListSkills = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Skill[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/skills`,options
    );
  }


export const getTwinsListSkillsQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twins/${id}/skills`];

    
export type TwinsListSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsListSkills>>>
export type TwinsListSkillsQueryError = AxiosError<void>

export const useTwinsListSkills = <TData = Awaited<ReturnType<typeof twinsListSkills>>, TError = AxiosError<void>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsListSkills>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsListSkillsQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsListSkills>>> = ({ signal }) => twinsListSkills(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsListSkills>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * @summary Add an existing skill to a twin
 */
export const twinsAddSkill = (
    org: string,
    id: string,
    skill: Skill, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/skills`,
      skill,options
    );
  }



    export type TwinsAddSkillMutationResult = NonNullable<Awaited<ReturnType<typeof twinsAddSkill>>>
    export type TwinsAddSkillMutationBody = Skill
    export type TwinsAddSkillMutationError = AxiosError<Failure>

    export const useTwinsAddSkill = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsAddSkill>>, TError,{org: string;id: string;data: Skill}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsAddSkill>>, {org: string;id: string;data: Skill}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsAddSkill(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsAddSkill>>, TError, {org: string;id: string;data: Skill}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Post a question to a twin by Id
 * @summary Retrieve sample questions from a twin
 */
export const twinsSuggestedQuestions = (
    org: string,
    id: string,
    params?: TwinsSuggestedQuestionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/${id}/questions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsSuggestedQuestionsQueryKey = (org: string,
    id: string,
    params?: TwinsSuggestedQuestionsParams,) => [`/api/v1/orgs/${org}/twin/${id}/questions`, ...(params ? [params]: [])];

    
export type TwinsSuggestedQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsSuggestedQuestions>>>
export type TwinsSuggestedQuestionsQueryError = AxiosError<Failure>

export const useTwinsSuggestedQuestions = <TData = Awaited<ReturnType<typeof twinsSuggestedQuestions>>, TError = AxiosError<Failure>>(
 org: string,
    id: string,
    params?: TwinsSuggestedQuestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsSuggestedQuestions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsSuggestedQuestionsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsSuggestedQuestions>>> = ({ signal }) => twinsSuggestedQuestions(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsSuggestedQuestions>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Crawl the url
 * @summary Crawl the url
 */
export const twinsCrawlUrl = (
    org: string,
    twinCrawlRequest: TwinCrawlRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinCrawlResult>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twin-crawl`,
      twinCrawlRequest,options
    );
  }



    export type TwinsCrawlUrlMutationResult = NonNullable<Awaited<ReturnType<typeof twinsCrawlUrl>>>
    export type TwinsCrawlUrlMutationBody = TwinCrawlRequest
    export type TwinsCrawlUrlMutationError = AxiosError<Failure>

    export const useTwinsCrawlUrl = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsCrawlUrl>>, TError,{org: string;data: TwinCrawlRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsCrawlUrl>>, {org: string;data: TwinCrawlRequest}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsCrawlUrl(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsCrawlUrl>>, TError, {org: string;data: TwinCrawlRequest}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Post a question to a twin by Id
 * @summary Post a question to a twin or a group of twins
 */
export const twinsAsk = (
    org: string,
    twinMessageNew: TwinMessageNew,
    params?: TwinsAskParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinDialogResult>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twin-dialog`,
      twinMessageNew,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsAskMutationResult = NonNullable<Awaited<ReturnType<typeof twinsAsk>>>
    export type TwinsAskMutationBody = TwinMessageNew
    export type TwinsAskMutationError = AxiosError<Failure>

    export const useTwinsAsk = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsAsk>>, TError,{org: string;data: TwinMessageNew;params?: TwinsAskParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsAsk>>, {org: string;data: TwinMessageNew;params?: TwinsAskParams}> = (props) => {
          const {org,data,params} = props ?? {};

          return  twinsAsk(org,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsAsk>>, TError, {org: string;data: TwinMessageNew;params?: TwinsAskParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update a message with a user response
 * @summary Respond with a user response
 */
export const twinsAnswer = (
    org: string,
    twinMessageAnswer: TwinMessageAnswer, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinMessage>> => {
    return axios.put(
      `/api/v1/orgs/${org}/twin-dialog`,
      twinMessageAnswer,options
    );
  }



    export type TwinsAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof twinsAnswer>>>
    export type TwinsAnswerMutationBody = TwinMessageAnswer
    export type TwinsAnswerMutationError = AxiosError<Failure>

    export const useTwinsAnswer = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsAnswer>>, TError,{org: string;data: TwinMessageAnswer}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsAnswer>>, {org: string;data: TwinMessageAnswer}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsAnswer(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsAnswer>>, TError, {org: string;data: TwinMessageAnswer}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update a message with a user feedback
 * @summary Respond with a user feedback
 */
export const twinsFeedback = (
    org: string,
    twinMessageFeedback: TwinMessageFeedback, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinMessage>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin-dialog`,
      twinMessageFeedback,options
    );
  }



    export type TwinsFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof twinsFeedback>>>
    export type TwinsFeedbackMutationBody = TwinMessageFeedback
    export type TwinsFeedbackMutationError = AxiosError<Failure>

    export const useTwinsFeedback = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsFeedback>>, TError,{org: string;data: TwinMessageFeedback}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsFeedback>>, {org: string;data: TwinMessageFeedback}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsFeedback(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsFeedback>>, TError, {org: string;data: TwinMessageFeedback}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * posting a question to a twin by id
 * @summary Streaming Q&A with a twin
 */
export const twinsDialog = (
    org: string,
    id: string,
    twinMessageNew: TwinMessageNew,
    params?: TwinsDialogParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/dialog-stream`,
      twinMessageNew,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsDialogMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDialog>>>
    export type TwinsDialogMutationBody = TwinMessageNew
    export type TwinsDialogMutationError = AxiosError<Failure>

    export const useTwinsDialog = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDialog>>, TError,{org: string;id: string;data: TwinMessageNew;params?: TwinsDialogParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDialog>>, {org: string;id: string;data: TwinMessageNew;params?: TwinsDialogParams}> = (props) => {
          const {org,id,data,params} = props ?? {};

          return  twinsDialog(org,id,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDialog>>, TError, {org: string;id: string;data: TwinMessageNew;params?: TwinsDialogParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * posting a question to a twin by id
 * @summary Streaming Q&A with a twin
 */
export const twinsMobiusDialog = (
    org: string,
    id: string,
    twinMessageNew: TwinMessageNew,
    params?: TwinsMobiusDialogParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/dialog-stream-mobius`,
      twinMessageNew,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsMobiusDialogMutationResult = NonNullable<Awaited<ReturnType<typeof twinsMobiusDialog>>>
    export type TwinsMobiusDialogMutationBody = TwinMessageNew
    export type TwinsMobiusDialogMutationError = AxiosError<Failure>

    export const useTwinsMobiusDialog = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsMobiusDialog>>, TError,{org: string;id: string;data: TwinMessageNew;params?: TwinsMobiusDialogParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsMobiusDialog>>, {org: string;id: string;data: TwinMessageNew;params?: TwinsMobiusDialogParams}> = (props) => {
          const {org,id,data,params} = props ?? {};

          return  twinsMobiusDialog(org,id,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsMobiusDialog>>, TError, {org: string;id: string;data: TwinMessageNew;params?: TwinsMobiusDialogParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Post a question to a twin by Id
 * @summary Post a question to a twin without creating a conversation
 */
export const twinsQuestion = (
    org: string,
    twinQuestion: TwinQuestion,
    params?: TwinsQuestionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinQuestionResult>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twin-question`,
      twinQuestion,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof twinsQuestion>>>
    export type TwinsQuestionMutationBody = TwinQuestion
    export type TwinsQuestionMutationError = AxiosError<Failure>

    export const useTwinsQuestion = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsQuestion>>, TError,{org: string;data: TwinQuestion;params?: TwinsQuestionParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsQuestion>>, {org: string;data: TwinQuestion;params?: TwinsQuestionParams}> = (props) => {
          const {org,data,params} = props ?? {};

          return  twinsQuestion(org,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsQuestion>>, TError, {org: string;data: TwinQuestion;params?: TwinsQuestionParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a message by id
 * @summary Returns a list of messages in descending order by twin Id
 */
export const twinsMessages = (
    org: string,
    id: string,
    params?: TwinsMessagesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinMessage[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin-messages/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsMessagesQueryKey = (org: string,
    id: string,
    params?: TwinsMessagesParams,) => [`/api/v1/orgs/${org}/twin-messages/${id}`, ...(params ? [params]: [])];

    
export type TwinsMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof twinsMessages>>>
export type TwinsMessagesQueryError = AxiosError<Failure>

export const useTwinsMessages = <TData = Awaited<ReturnType<typeof twinsMessages>>, TError = AxiosError<Failure>>(
 org: string,
    id: string,
    params?: TwinsMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsMessages>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsMessagesQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsMessages>>> = ({ signal }) => twinsMessages(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsMessages>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of converations by recently updated
 * @summary Returns a list of converations
 */
export const twinsConversations = (
    org: string,
    params?: TwinsConversationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinConversationGroup[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin-conversations`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsConversationsQueryKey = (org: string,
    params?: TwinsConversationsParams,) => [`/api/v1/orgs/${org}/twin-conversations`, ...(params ? [params]: [])];

    
export type TwinsConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsConversations>>>
export type TwinsConversationsQueryError = AxiosError<Failure>

export const useTwinsConversations = <TData = Awaited<ReturnType<typeof twinsConversations>>, TError = AxiosError<Failure>>(
 org: string,
    params?: TwinsConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsConversations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsConversationsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsConversations>>> = ({ signal }) => twinsConversations(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsConversations>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a conversation for the user by tag
 * @summary Returns a conversation for the user by tag
 */
export const twinsConversation = (
    org: string,
    id: string,
    params?: TwinsConversationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinConversation | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin-conversation/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsConversationQueryKey = (org: string,
    id: string,
    params?: TwinsConversationParams,) => [`/api/v1/orgs/${org}/twin-conversation/${id}`, ...(params ? [params]: [])];

    
export type TwinsConversationQueryResult = NonNullable<Awaited<ReturnType<typeof twinsConversation>>>
export type TwinsConversationQueryError = AxiosError<Failure>

export const useTwinsConversation = <TData = Awaited<ReturnType<typeof twinsConversation>>, TError = AxiosError<Failure>>(
 org: string,
    id: string,
    params?: TwinsConversationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsConversation>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsConversationQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsConversation>>> = ({ signal }) => twinsConversation(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsConversation>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * delete twin conversation
 * @summary delete twin conversation
 */
export const twinsDeleteConversation = (
    org: string,
    id: string,
    params?: TwinsDeleteConversationParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twin-conversation/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsDeleteConversationMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeleteConversation>>>
    
    export type TwinsDeleteConversationMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsDeleteConversation = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeleteConversation>>, TError,{org: string;id: string;params?: TwinsDeleteConversationParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeleteConversation>>, {org: string;id: string;params?: TwinsDeleteConversationParams}> = (props) => {
          const {org,id,params} = props ?? {};

          return  twinsDeleteConversation(org,id,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeleteConversation>>, TError, {org: string;id: string;params?: TwinsDeleteConversationParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update conversation with user viewed status
 * @summary Update viewed status
 */
export const twinsConversationViewed = (
    org: string,
    id: string,
    params?: TwinsConversationViewedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinConversation>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin-conversation/${id}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsConversationViewedMutationResult = NonNullable<Awaited<ReturnType<typeof twinsConversationViewed>>>
    
    export type TwinsConversationViewedMutationError = AxiosError<Failure>

    export const useTwinsConversationViewed = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsConversationViewed>>, TError,{org: string;id: string;params?: TwinsConversationViewedParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsConversationViewed>>, {org: string;id: string;params?: TwinsConversationViewedParams}> = (props) => {
          const {org,id,params} = props ?? {};

          return  twinsConversationViewed(org,id,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsConversationViewed>>, TError, {org: string;id: string;params?: TwinsConversationViewedParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Clear messages from the conversation
 * @summary Clear messages from the conversation
 */
export const twinsConversationClear = (
    org: string,
    id: string,
    params?: TwinsConversationClearParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinConversation>> => {
    return axios.put(
      `/api/v1/orgs/${org}/twin-conversation/${id}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsConversationClearMutationResult = NonNullable<Awaited<ReturnType<typeof twinsConversationClear>>>
    
    export type TwinsConversationClearMutationError = AxiosError<Failure>

    export const useTwinsConversationClear = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsConversationClear>>, TError,{org: string;id: string;params?: TwinsConversationClearParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsConversationClear>>, {org: string;id: string;params?: TwinsConversationClearParams}> = (props) => {
          const {org,id,params} = props ?? {};

          return  twinsConversationClear(org,id,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsConversationClear>>, TError, {org: string;id: string;params?: TwinsConversationClearParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a conversation for the user by tag
 * @summary Returns a conversation for the user by tag
 */
export const twinsConversationByTag = (
    org: string,
    params: TwinsConversationByTagParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinConversation | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin-conversation-by-tag`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsConversationByTagQueryKey = (org: string,
    params: TwinsConversationByTagParams,) => [`/api/v1/orgs/${org}/twin-conversation-by-tag`, ...(params ? [params]: [])];

    
export type TwinsConversationByTagQueryResult = NonNullable<Awaited<ReturnType<typeof twinsConversationByTag>>>
export type TwinsConversationByTagQueryError = AxiosError<Failure>

export const useTwinsConversationByTag = <TData = Awaited<ReturnType<typeof twinsConversationByTag>>, TError = AxiosError<Failure>>(
 org: string,
    params: TwinsConversationByTagParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsConversationByTag>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsConversationByTagQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsConversationByTag>>> = ({ signal }) => twinsConversationByTag(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsConversationByTag>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a full note by id
 * @summary Returns a full note
 */
export const twinsGetConversationCounts = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinConversationCounts | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin-conversation/counts`,options
    );
  }


export const getTwinsGetConversationCountsQueryKey = (org: string,) => [`/api/v1/orgs/${org}/twin-conversation/counts`];

    
export type TwinsGetConversationCountsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetConversationCounts>>>
export type TwinsGetConversationCountsQueryError = AxiosError<Failure>

export const useTwinsGetConversationCounts = <TData = Awaited<ReturnType<typeof twinsGetConversationCounts>>, TError = AxiosError<Failure>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetConversationCounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetConversationCountsQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetConversationCounts>>> = ({ signal }) => twinsGetConversationCounts(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetConversationCounts>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Find employees via various criteria. This method returns up to 100 results [per page](https://docs.github.com/rest/overview/resources-in-the-rest-api#pagination).

When searching for users, you can get text match metadata for the issue **login**, **email**, and **name** fields when you pass the `text-match` media type. For more details about highlighting search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata). For more details about how to receive highlighted search results, see [Text match metadata](https://docs.github.com/rest/reference/search#text-match-metadata).

For example, if you're looking for a list of popular users, you might try this query:

`q=tom+repos:%3E42+followers:%3E1000`

This query searches for users with the name `tom`. The results are restricted to users with more than 42 repositories and over 1,000 followers.
 * @summary Search twins
 */
export const searchTwins = (
    org: string,
    params: SearchTwinsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchResultsTwins>> => {
    return axios.get(
      `/api/v1/orgs/${org}/search/twins`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSearchTwinsQueryKey = (org: string,
    params: SearchTwinsParams,) => [`/api/v1/orgs/${org}/search/twins`, ...(params ? [params]: [])];

    
export type SearchTwinsQueryResult = NonNullable<Awaited<ReturnType<typeof searchTwins>>>
export type SearchTwinsQueryError = AxiosError<NotModifiedResponse | ValidationFailedResponse>

export const useSearchTwins = <TData = Awaited<ReturnType<typeof searchTwins>>, TError = AxiosError<NotModifiedResponse | ValidationFailedResponse>>(
 org: string,
    params: SearchTwinsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchTwins>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchTwinsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchTwins>>> = ({ signal }) => searchTwins(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof searchTwins>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of notes by id
 * @summary Returns a list of notes in descending order for my twin
 */
export const twinsNotes = (
    org: string,
    params?: TwinsNotesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinNoteSummary[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/notes`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsNotesQueryKey = (org: string,
    params?: TwinsNotesParams,) => [`/api/v1/orgs/${org}/twin/notes`, ...(params ? [params]: [])];

    
export type TwinsNotesQueryResult = NonNullable<Awaited<ReturnType<typeof twinsNotes>>>
export type TwinsNotesQueryError = AxiosError<Failure>

export const useTwinsNotes = <TData = Awaited<ReturnType<typeof twinsNotes>>, TError = AxiosError<Failure>>(
 org: string,
    params?: TwinsNotesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsNotes>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsNotesQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsNotes>>> = ({ signal }) => twinsNotes(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsNotes>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Post new twin note
 * @summary Post new twin note
 */
export const twinsNewNote = (
    org: string,
    twinNoteNew: TwinNoteNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinNote>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twin/notes`,
      twinNoteNew,options
    );
  }



    export type TwinsNewNoteMutationResult = NonNullable<Awaited<ReturnType<typeof twinsNewNote>>>
    export type TwinsNewNoteMutationBody = TwinNoteNew
    export type TwinsNewNoteMutationError = AxiosError<Failure>

    export const useTwinsNewNote = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsNewNote>>, TError,{org: string;data: TwinNoteNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsNewNote>>, {org: string;data: TwinNoteNew}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsNewNote(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsNewNote>>, TError, {org: string;data: TwinNoteNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update search scope on user notes
 * @summary Update search scope on user notes
 */
export const twinsUpdateNotesScope = (
    org: string,
    searchScopeUpdate: SearchScopeUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin/notes`,
      searchScopeUpdate,options
    );
  }



    export type TwinsUpdateNotesScopeMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdateNotesScope>>>
    export type TwinsUpdateNotesScopeMutationBody = SearchScopeUpdate
    export type TwinsUpdateNotesScopeMutationError = AxiosError<Failure>

    export const useTwinsUpdateNotesScope = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdateNotesScope>>, TError,{org: string;data: SearchScopeUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdateNotesScope>>, {org: string;data: SearchScopeUpdate}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsUpdateNotesScope(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdateNotesScope>>, TError, {org: string;data: SearchScopeUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete the note for the twin
 * @summary delete twins notes
 */
export const twinsDeleteNotes = (
    org: string,
    twinsDeleteNotesBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twin/notes`,{data:
      twinsDeleteNotesBody, ...options}
    );
  }



    export type TwinsDeleteNotesMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeleteNotes>>>
    export type TwinsDeleteNotesMutationBody = string[]
    export type TwinsDeleteNotesMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsDeleteNotes = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeleteNotes>>, TError,{org: string;data: string[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeleteNotes>>, {org: string;data: string[]}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsDeleteNotes(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeleteNotes>>, TError, {org: string;data: string[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a full note by id
 * @summary Returns a full note
 */
export const twinsGetNote = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinNote | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/note/${id}`,options
    );
  }


export const getTwinsGetNoteQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twin/note/${id}`];

    
export type TwinsGetNoteQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetNote>>>
export type TwinsGetNoteQueryError = AxiosError<Failure>

export const useTwinsGetNote = <TData = Awaited<ReturnType<typeof twinsGetNote>>, TError = AxiosError<Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetNote>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetNoteQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetNote>>> = ({ signal }) => twinsGetNote(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetNote>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update a message with a user response
 * @summary Update user note
 */
export const twinsUpdateNote = (
    org: string,
    id: string,
    twinNoteUpdate: TwinNoteUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinNote>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin/note/${id}`,
      twinNoteUpdate,options
    );
  }



    export type TwinsUpdateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdateNote>>>
    export type TwinsUpdateNoteMutationBody = TwinNoteUpdate
    export type TwinsUpdateNoteMutationError = AxiosError<Failure>

    export const useTwinsUpdateNote = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdateNote>>, TError,{org: string;id: string;data: TwinNoteUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdateNote>>, {org: string;id: string;data: TwinNoteUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsUpdateNote(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdateNote>>, TError, {org: string;id: string;data: TwinNoteUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete the note for the twin
 * @summary delete twins note
 */
export const twinsDeleteNote = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twin/note/${id}`,options
    );
  }



    export type TwinsDeleteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeleteNote>>>
    
    export type TwinsDeleteNoteMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsDeleteNote = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeleteNote>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeleteNote>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  twinsDeleteNote(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeleteNote>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a full note by id
 * @summary Returns a full note
 */
export const twinsGetMessageDetails = (
    org: string,
    id: string,
    messageId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinDialogStreamResult | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/${id}/twin-messages/${messageId}`,options
    );
  }


export const getTwinsGetMessageDetailsQueryKey = (org: string,
    id: string,
    messageId: string,) => [`/api/v1/orgs/${org}/twin/${id}/twin-messages/${messageId}`];

    
export type TwinsGetMessageDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetMessageDetails>>>
export type TwinsGetMessageDetailsQueryError = AxiosError<Failure>

export const useTwinsGetMessageDetails = <TData = Awaited<ReturnType<typeof twinsGetMessageDetails>>, TError = AxiosError<Failure>>(
 org: string,
    id: string,
    messageId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetMessageDetails>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetMessageDetailsQueryKey(org,id,messageId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetMessageDetails>>> = ({ signal }) => twinsGetMessageDetails(org,id,messageId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetMessageDetails>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id && messageId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * @summary Returns a single twin instructon for a twin by id
 */
export const twinsGetInstruction = (
    org: string,
    id: string,
    instructionId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInstruction>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/${id}/instruction/${instructionId}`,options
    );
  }


export const getTwinsGetInstructionQueryKey = (org: string,
    id: string,
    instructionId: string,) => [`/api/v1/orgs/${org}/twin/${id}/instruction/${instructionId}`];

    
export type TwinsGetInstructionQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetInstruction>>>
export type TwinsGetInstructionQueryError = AxiosError<void>

export const useTwinsGetInstruction = <TData = Awaited<ReturnType<typeof twinsGetInstruction>>, TError = AxiosError<void>>(
 org: string,
    id: string,
    instructionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetInstruction>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetInstructionQueryKey(org,id,instructionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetInstruction>>> = ({ signal }) => twinsGetInstruction(org,id,instructionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetInstruction>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id && instructionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update twin instruction
 * @summary Update twin instruction
 */
export const twinsUpdateInstruction = (
    org: string,
    id: string,
    instructionId: string,
    twinInstructionUpdate: TwinInstructionUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInstruction>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin/${id}/instruction/${instructionId}`,
      twinInstructionUpdate,options
    );
  }



    export type TwinsUpdateInstructionMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdateInstruction>>>
    export type TwinsUpdateInstructionMutationBody = TwinInstructionUpdate
    export type TwinsUpdateInstructionMutationError = AxiosError<Failure>

    export const useTwinsUpdateInstruction = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdateInstruction>>, TError,{org: string;id: string;instructionId: string;data: TwinInstructionUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdateInstruction>>, {org: string;id: string;instructionId: string;data: TwinInstructionUpdate}> = (props) => {
          const {org,id,instructionId,data} = props ?? {};

          return  twinsUpdateInstruction(org,id,instructionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdateInstruction>>, TError, {org: string;id: string;instructionId: string;data: TwinInstructionUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete twin instruction
 * @summary delete twin instruction
 */
export const twinsDeleteInstruction = (
    org: string,
    id: string,
    instructionId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twin/${id}/instruction/${instructionId}`,options
    );
  }



    export type TwinsDeleteInstructionMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeleteInstruction>>>
    
    export type TwinsDeleteInstructionMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsDeleteInstruction = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeleteInstruction>>, TError,{org: string;id: string;instructionId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeleteInstruction>>, {org: string;id: string;instructionId: string}> = (props) => {
          const {org,id,instructionId} = props ?? {};

          return  twinsDeleteInstruction(org,id,instructionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeleteInstruction>>, TError, {org: string;id: string;instructionId: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List insights for a twin
 * @summary List insights for a twin
 */
export const twinsListInsights = (
    org: string,
    id: string,
    params?: TwinsListInsightsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInsightsWithLatest>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/${id}/insights`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsListInsightsQueryKey = (org: string,
    id: string,
    params?: TwinsListInsightsParams,) => [`/api/v1/orgs/${org}/twin/${id}/insights`, ...(params ? [params]: [])];

    
export type TwinsListInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsListInsights>>>
export type TwinsListInsightsQueryError = AxiosError<unknown>

export const useTwinsListInsights = <TData = Awaited<ReturnType<typeof twinsListInsights>>, TError = AxiosError<unknown>>(
 org: string,
    id: string,
    params?: TwinsListInsightsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsListInsights>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsListInsightsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsListInsights>>> = ({ signal }) => twinsListInsights(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsListInsights>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * trigger slack insights build
 * @summary trigger slack insights build
 */
export const slackBuildInsights = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/slack`,undefined,options
    );
  }



    export type SlackBuildInsightsMutationResult = NonNullable<Awaited<ReturnType<typeof slackBuildInsights>>>
    
    export type SlackBuildInsightsMutationError = AxiosError<unknown>

    export const useSlackBuildInsights = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof slackBuildInsights>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof slackBuildInsights>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  slackBuildInsights(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof slackBuildInsights>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * trigger cluster build
 * @summary trigger cluster build
 */
export const trendsBuild = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twins/${id}/trends`,undefined,options
    );
  }



    export type TrendsBuildMutationResult = NonNullable<Awaited<ReturnType<typeof trendsBuild>>>
    
    export type TrendsBuildMutationError = AxiosError<unknown>

    export const useTrendsBuild = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trendsBuild>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trendsBuild>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  trendsBuild(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof trendsBuild>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a list of trends
 * @summary Returns a list of trends
 */
export const trendsListTrends = (
    org: string,
    id: string,
    params: TrendsListTrendsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Trend[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/trends`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTrendsListTrendsQueryKey = (org: string,
    id: string,
    params: TrendsListTrendsParams,) => [`/api/v1/orgs/${org}/twins/${id}/trends`, ...(params ? [params]: [])];

    
export type TrendsListTrendsQueryResult = NonNullable<Awaited<ReturnType<typeof trendsListTrends>>>
export type TrendsListTrendsQueryError = AxiosError<unknown>

export const useTrendsListTrends = <TData = Awaited<ReturnType<typeof trendsListTrends>>, TError = AxiosError<unknown>>(
 org: string,
    id: string,
    params: TrendsListTrendsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof trendsListTrends>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendsListTrendsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendsListTrends>>> = ({ signal }) => trendsListTrends(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof trendsListTrends>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of companies with trends
 * @summary Returns a list of companies with trends
 */
export const trendsGetCompanies = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TrendCompany[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/trends/companies`,options
    );
  }


export const getTrendsGetCompaniesQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twins/${id}/trends/companies`];

    
export type TrendsGetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof trendsGetCompanies>>>
export type TrendsGetCompaniesQueryError = AxiosError<unknown>

export const useTrendsGetCompanies = <TData = Awaited<ReturnType<typeof trendsGetCompanies>>, TError = AxiosError<unknown>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof trendsGetCompanies>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendsGetCompaniesQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendsGetCompanies>>> = ({ signal }) => trendsGetCompanies(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof trendsGetCompanies>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of topics for a twin
 * @summary Returns a list of topics for a twin
 */
export const trendsGetTopics = (
    org: string,
    id: string,
    params?: TrendsGetTopicsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TrendTopic[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/trends/topics`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTrendsGetTopicsQueryKey = (org: string,
    id: string,
    params?: TrendsGetTopicsParams,) => [`/api/v1/orgs/${org}/twins/${id}/trends/topics`, ...(params ? [params]: [])];

    
export type TrendsGetTopicsQueryResult = NonNullable<Awaited<ReturnType<typeof trendsGetTopics>>>
export type TrendsGetTopicsQueryError = AxiosError<unknown>

export const useTrendsGetTopics = <TData = Awaited<ReturnType<typeof trendsGetTopics>>, TError = AxiosError<unknown>>(
 org: string,
    id: string,
    params?: TrendsGetTopicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof trendsGetTopics>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendsGetTopicsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendsGetTopics>>> = ({ signal }) => trendsGetTopics(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof trendsGetTopics>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of topic types for a twin
 * @summary Returns a list of topic types for a twin
 */
export const trendsGetTopicTypes = (
    org: string,
    id: string,
    params: TrendsGetTopicTypesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[] | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twins/${id}/trends/topic-types`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTrendsGetTopicTypesQueryKey = (org: string,
    id: string,
    params: TrendsGetTopicTypesParams,) => [`/api/v1/orgs/${org}/twins/${id}/trends/topic-types`, ...(params ? [params]: [])];

    
export type TrendsGetTopicTypesQueryResult = NonNullable<Awaited<ReturnType<typeof trendsGetTopicTypes>>>
export type TrendsGetTopicTypesQueryError = AxiosError<unknown>

export const useTrendsGetTopicTypes = <TData = Awaited<ReturnType<typeof trendsGetTopicTypes>>, TError = AxiosError<unknown>>(
 org: string,
    id: string,
    params: TrendsGetTopicTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof trendsGetTopicTypes>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTrendsGetTopicTypesQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof trendsGetTopicTypes>>> = ({ signal }) => trendsGetTopicTypes(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof trendsGetTopicTypes>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a twin by short_url
 * @summary Returns a twin by short_url
 */
export const twinsGetSharedTwin = (
    org: string,
    shortUrl: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin>> => {
    return axios.get(
      `/api/v1/orgs/${org}/shared/${shortUrl}`,options
    );
  }


export const getTwinsGetSharedTwinQueryKey = (org: string,
    shortUrl: string,) => [`/api/v1/orgs/${org}/shared/${shortUrl}`];

    
export type TwinsGetSharedTwinQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetSharedTwin>>>
export type TwinsGetSharedTwinQueryError = AxiosError<void | Failure>

export const useTwinsGetSharedTwin = <TData = Awaited<ReturnType<typeof twinsGetSharedTwin>>, TError = AxiosError<void | Failure>>(
 org: string,
    shortUrl: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetSharedTwin>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetSharedTwinQueryKey(org,shortUrl);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetSharedTwin>>> = ({ signal }) => twinsGetSharedTwin(org,shortUrl, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetSharedTwin>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && shortUrl), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * @summary Returns a list of twin instructons for a twin by id
 */
export const twinsListInstructions = (
    org: string,
    id: string,
    params?: TwinsListInstructionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInstruction[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/${id}/instructions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsListInstructionsQueryKey = (org: string,
    id: string,
    params?: TwinsListInstructionsParams,) => [`/api/v1/orgs/${org}/twin/${id}/instructions`, ...(params ? [params]: [])];

    
export type TwinsListInstructionsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsListInstructions>>>
export type TwinsListInstructionsQueryError = AxiosError<void>

export const useTwinsListInstructions = <TData = Awaited<ReturnType<typeof twinsListInstructions>>, TError = AxiosError<void>>(
 org: string,
    id: string,
    params?: TwinsListInstructionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsListInstructions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsListInstructionsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsListInstructions>>> = ({ signal }) => twinsListInstructions(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsListInstructions>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Crate new twin instruction
 * @summary Create new twin instruction
 */
export const twinsNewInstruction = (
    org: string,
    id: string,
    twinInstructionNew: TwinInstructionNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInstruction>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twin/${id}/instructions`,
      twinInstructionNew,options
    );
  }



    export type TwinsNewInstructionMutationResult = NonNullable<Awaited<ReturnType<typeof twinsNewInstruction>>>
    export type TwinsNewInstructionMutationBody = TwinInstructionNew
    export type TwinsNewInstructionMutationError = AxiosError<Failure>

    export const useTwinsNewInstruction = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsNewInstruction>>, TError,{org: string;id: string;data: TwinInstructionNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsNewInstruction>>, {org: string;id: string;data: TwinInstructionNew}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsNewInstruction(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsNewInstruction>>, TError, {org: string;id: string;data: TwinInstructionNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Set explicit order for instructions
 * @summary Set explicit order for instructions
 */
export const twinsOrderInstructions = (
    org: string,
    id: string,
    twinsOrderInstructionsBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinInstruction[]>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin/${id}/instructions`,
      twinsOrderInstructionsBody,options
    );
  }



    export type TwinsOrderInstructionsMutationResult = NonNullable<Awaited<ReturnType<typeof twinsOrderInstructions>>>
    export type TwinsOrderInstructionsMutationBody = string[]
    export type TwinsOrderInstructionsMutationError = AxiosError<Failure>

    export const useTwinsOrderInstructions = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsOrderInstructions>>, TError,{org: string;id: string;data: string[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsOrderInstructions>>, {org: string;id: string;data: string[]}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsOrderInstructions(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsOrderInstructions>>, TError, {org: string;id: string;data: string[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * verify if short url is available
 * @summary verify if short url is available
 */
export const twinsValidateShortUrl = (
    org: string,
    id: string,
    params: TwinsValidateShortUrlParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ShortUrlAvailability>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/${id}/short_url`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsValidateShortUrlQueryKey = (org: string,
    id: string,
    params: TwinsValidateShortUrlParams,) => [`/api/v1/orgs/${org}/twin/${id}/short_url`, ...(params ? [params]: [])];

    
export type TwinsValidateShortUrlQueryResult = NonNullable<Awaited<ReturnType<typeof twinsValidateShortUrl>>>
export type TwinsValidateShortUrlQueryError = AxiosError<Failure>

export const useTwinsValidateShortUrl = <TData = Awaited<ReturnType<typeof twinsValidateShortUrl>>, TError = AxiosError<Failure>>(
 org: string,
    id: string,
    params: TwinsValidateShortUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsValidateShortUrl>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsValidateShortUrlQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsValidateShortUrl>>> = ({ signal }) => twinsValidateShortUrl(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsValidateShortUrl>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of prompts
 * @summary Returns a list of prompts sorted by name
 */
export const twinsPrompts = (
    org: string,
    params?: TwinsPromptsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinPrompt[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/prompts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsPromptsQueryKey = (org: string,
    params?: TwinsPromptsParams,) => [`/api/v1/orgs/${org}/twin/prompts`, ...(params ? [params]: [])];

    
export type TwinsPromptsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsPrompts>>>
export type TwinsPromptsQueryError = AxiosError<Failure>

export const useTwinsPrompts = <TData = Awaited<ReturnType<typeof twinsPrompts>>, TError = AxiosError<Failure>>(
 org: string,
    params?: TwinsPromptsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsPrompts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsPromptsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsPrompts>>> = ({ signal }) => twinsPrompts(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsPrompts>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of prompts
 * @summary Reset prompts to default and returns a list of prompts sorted by name
 */
export const twinsResetPrompts = (
    org: string,
    params?: TwinsResetPromptsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinPrompt[]>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin/prompts`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type TwinsResetPromptsMutationResult = NonNullable<Awaited<ReturnType<typeof twinsResetPrompts>>>
    
    export type TwinsResetPromptsMutationError = AxiosError<Failure>

    export const useTwinsResetPrompts = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsResetPrompts>>, TError,{org: string;params?: TwinsResetPromptsParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsResetPrompts>>, {org: string;params?: TwinsResetPromptsParams}> = (props) => {
          const {org,params} = props ?? {};

          return  twinsResetPrompts(org,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsResetPrompts>>, TError, {org: string;params?: TwinsResetPromptsParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Post new twin note
 * @summary Post new twin prompt
 */
export const twinsNewPrompt = (
    org: string,
    twinPromptNew: TwinPromptNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinPrompt>> => {
    return axios.post(
      `/api/v1/orgs/${org}/twin/prompts`,
      twinPromptNew,options
    );
  }



    export type TwinsNewPromptMutationResult = NonNullable<Awaited<ReturnType<typeof twinsNewPrompt>>>
    export type TwinsNewPromptMutationBody = TwinPromptNew
    export type TwinsNewPromptMutationError = AxiosError<Failure>

    export const useTwinsNewPrompt = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsNewPrompt>>, TError,{org: string;data: TwinPromptNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsNewPrompt>>, {org: string;data: TwinPromptNew}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsNewPrompt(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsNewPrompt>>, TError, {org: string;data: TwinPromptNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a prompt by id
 * @summary Returns the prompt
 */
export const twinsGetPrompt = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinPrompt | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/prompt/${id}`,options
    );
  }


export const getTwinsGetPromptQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/twin/prompt/${id}`];

    
export type TwinsGetPromptQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetPrompt>>>
export type TwinsGetPromptQueryError = AxiosError<Failure>

export const useTwinsGetPrompt = <TData = Awaited<ReturnType<typeof twinsGetPrompt>>, TError = AxiosError<Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetPrompt>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetPromptQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetPrompt>>> = ({ signal }) => twinsGetPrompt(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetPrompt>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update a message with a user response
 * @summary Update the prompt
 */
export const twinsUpdatePrompt = (
    org: string,
    id: string,
    twinPromptUpdate: TwinPromptUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinPrompt>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/twin/prompt/${id}`,
      twinPromptUpdate,options
    );
  }



    export type TwinsUpdatePromptMutationResult = NonNullable<Awaited<ReturnType<typeof twinsUpdatePrompt>>>
    export type TwinsUpdatePromptMutationBody = TwinPromptUpdate
    export type TwinsUpdatePromptMutationError = AxiosError<Failure>

    export const useTwinsUpdatePrompt = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsUpdatePrompt>>, TError,{org: string;id: string;data: TwinPromptUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsUpdatePrompt>>, {org: string;id: string;data: TwinPromptUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  twinsUpdatePrompt(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsUpdatePrompt>>, TError, {org: string;id: string;data: TwinPromptUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete the prompt for the twin
 * @summary delete twins prompt
 */
export const twinsDeletePrompt = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twin/prompt/${id}`,options
    );
  }



    export type TwinsDeletePromptMutationResult = NonNullable<Awaited<ReturnType<typeof twinsDeletePrompt>>>
    
    export type TwinsDeletePromptMutationError = AxiosError<NotFoundResponse | Failure>

    export const useTwinsDeletePrompt = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsDeletePrompt>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsDeletePrompt>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  twinsDeletePrompt(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsDeletePrompt>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a list of suggested documents
 * @summary Returns a list of suggested documents sorted by name
 */
export const twinsGetSuggestedDocuments = (
    org: string,
    params?: TwinsGetSuggestedDocumentsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SourceDocumentNew[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/twin/suggested-documents`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getTwinsGetSuggestedDocumentsQueryKey = (org: string,
    params?: TwinsGetSuggestedDocumentsParams,) => [`/api/v1/orgs/${org}/twin/suggested-documents`, ...(params ? [params]: [])];

    
export type TwinsGetSuggestedDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetSuggestedDocuments>>>
export type TwinsGetSuggestedDocumentsQueryError = AxiosError<Failure>

export const useTwinsGetSuggestedDocuments = <TData = Awaited<ReturnType<typeof twinsGetSuggestedDocuments>>, TError = AxiosError<Failure>>(
 org: string,
    params?: TwinsGetSuggestedDocumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetSuggestedDocuments>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetSuggestedDocumentsQueryKey(org,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetSuggestedDocuments>>> = ({ signal }) => twinsGetSuggestedDocuments(org,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetSuggestedDocuments>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Hide a suggested document from the twin
 * @summary Hide a suggested document from the twin
 */
export const twinsHideSuggestedDocument = (
    org: string,
    sourceDocumentNew: SourceDocumentNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/twin/suggested-documents`,{data:
      sourceDocumentNew, ...options}
    );
  }



    export type TwinsHideSuggestedDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof twinsHideSuggestedDocument>>>
    export type TwinsHideSuggestedDocumentMutationBody = SourceDocumentNew
    export type TwinsHideSuggestedDocumentMutationError = AxiosError<Failure>

    export const useTwinsHideSuggestedDocument = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof twinsHideSuggestedDocument>>, TError,{org: string;data: SourceDocumentNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof twinsHideSuggestedDocument>>, {org: string;data: SourceDocumentNew}> = (props) => {
          const {org,data} = props ?? {};

          return  twinsHideSuggestedDocument(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof twinsHideSuggestedDocument>>, TError, {org: string;data: SourceDocumentNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a twin responder by twin Id
 * @summary Returns a twin responder by twin Id
 */
export const usersGetTwinResponder = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponder>> => {
    return axios.get(
      `/api/v1/orgs/${org}/user/twin-responder/${id}`,options
    );
  }


export const getUsersGetTwinResponderQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/user/twin-responder/${id}`];

    
export type UsersGetTwinResponderQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetTwinResponder>>>
export type UsersGetTwinResponderQueryError = AxiosError<void | Failure>

export const useUsersGetTwinResponder = <TData = Awaited<ReturnType<typeof usersGetTwinResponder>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTwinResponder>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetTwinResponderQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetTwinResponder>>> = ({ signal }) => usersGetTwinResponder(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetTwinResponder>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Enables an authenticated organization owner with the `org:w` scope to update the employee's profile.
 * @summary Update twin responder
 */
export const usersUpdateTwinResponder = (
    org: string,
    id: string,
    twinResponderUpdate: TwinResponderUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponder>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/user/twin-responder/${id}`,
      twinResponderUpdate,options
    );
  }



    export type UsersUpdateTwinResponderMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateTwinResponder>>>
    export type UsersUpdateTwinResponderMutationBody = TwinResponderUpdate
    export type UsersUpdateTwinResponderMutationError = AxiosError<Failure>

    export const useUsersUpdateTwinResponder = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateTwinResponder>>, TError,{org: string;id: string;data: TwinResponderUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateTwinResponder>>, {org: string;id: string;data: TwinResponderUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  usersUpdateTwinResponder(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersUpdateTwinResponder>>, TError, {org: string;id: string;data: TwinResponderUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns labels for twin responder
 * @summary Returns labels for twin responder
 */
export const usersGetTwinResponderLabels = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderLabel[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/user/twin-responder/${id}/labels`,options
    );
  }


export const getUsersGetTwinResponderLabelsQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/user/twin-responder/${id}/labels`];

    
export type UsersGetTwinResponderLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetTwinResponderLabels>>>
export type UsersGetTwinResponderLabelsQueryError = AxiosError<void | Failure>

export const useUsersGetTwinResponderLabels = <TData = Awaited<ReturnType<typeof usersGetTwinResponderLabels>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTwinResponderLabels>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetTwinResponderLabelsQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetTwinResponderLabels>>> = ({ signal }) => usersGetTwinResponderLabels(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetTwinResponderLabels>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * @summary select gmail labels for twin responder
 */
export const usersUpdateTwinResponderLabels = (
    org: string,
    id: string,
    usersUpdateTwinResponderLabelsBody: string[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.post(
      `/api/v1/orgs/${org}/user/twin-responder/${id}/labels`,
      usersUpdateTwinResponderLabelsBody,options
    );
  }



    export type UsersUpdateTwinResponderLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateTwinResponderLabels>>>
    export type UsersUpdateTwinResponderLabelsMutationBody = string[]
    export type UsersUpdateTwinResponderLabelsMutationError = AxiosError<unknown>

    export const useUsersUpdateTwinResponderLabels = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateTwinResponderLabels>>, TError,{org: string;id: string;data: string[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateTwinResponderLabels>>, {org: string;id: string;data: string[]}> = (props) => {
          const {org,id,data} = props ?? {};

          return  usersUpdateTwinResponderLabels(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersUpdateTwinResponderLabels>>, TError, {org: string;id: string;data: string[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a responder stats by twin Id
 * @summary Returns a responder stats by twin Id
 */
export const usersGetTwinResponderStats = (
    org: string,
    id: string,
    params: UsersGetTwinResponderStatsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderStats>> => {
    return axios.get(
      `/api/v1/orgs/${org}/user/twin-responder/${id}/stats`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUsersGetTwinResponderStatsQueryKey = (org: string,
    id: string,
    params: UsersGetTwinResponderStatsParams,) => [`/api/v1/orgs/${org}/user/twin-responder/${id}/stats`, ...(params ? [params]: [])];

    
export type UsersGetTwinResponderStatsQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetTwinResponderStats>>>
export type UsersGetTwinResponderStatsQueryError = AxiosError<void | Failure>

export const useUsersGetTwinResponderStats = <TData = Awaited<ReturnType<typeof usersGetTwinResponderStats>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string,
    params: UsersGetTwinResponderStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTwinResponderStats>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetTwinResponderStatsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetTwinResponderStats>>> = ({ signal }) => usersGetTwinResponderStats(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetTwinResponderStats>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns threads for twin responder
 * @summary Returns threads for twin responder
 */
export const usersGetTwinResponderThreads = (
    org: string,
    id: string,
    params: UsersGetTwinResponderThreadsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderThreads>> => {
    return axios.get(
      `/api/v1/orgs/${org}/user/twin-responder/${id}/threads`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUsersGetTwinResponderThreadsQueryKey = (org: string,
    id: string,
    params: UsersGetTwinResponderThreadsParams,) => [`/api/v1/orgs/${org}/user/twin-responder/${id}/threads`, ...(params ? [params]: [])];

    
export type UsersGetTwinResponderThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetTwinResponderThreads>>>
export type UsersGetTwinResponderThreadsQueryError = AxiosError<void | Failure>

export const useUsersGetTwinResponderThreads = <TData = Awaited<ReturnType<typeof usersGetTwinResponderThreads>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string,
    params: UsersGetTwinResponderThreadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTwinResponderThreads>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetTwinResponderThreadsQueryKey(org,id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetTwinResponderThreads>>> = ({ signal }) => usersGetTwinResponderThreads(org,id,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetTwinResponderThreads>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Return full thread with all the emails by id
 * @summary Return full thread with all the emails by id
 */
export const usersGetTwinResponderThread = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderThread>> => {
    return axios.get(
      `/api/v1/orgs/${org}/user/twin-responder/threads/${id}`,options
    );
  }


export const getUsersGetTwinResponderThreadQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/user/twin-responder/threads/${id}`];

    
export type UsersGetTwinResponderThreadQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetTwinResponderThread>>>
export type UsersGetTwinResponderThreadQueryError = AxiosError<void | Failure>

export const useUsersGetTwinResponderThread = <TData = Awaited<ReturnType<typeof usersGetTwinResponderThread>>, TError = AxiosError<void | Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTwinResponderThread>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetTwinResponderThreadQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetTwinResponderThread>>> = ({ signal }) => usersGetTwinResponderThread(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetTwinResponderThread>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Trigger a respond call for a thread
 * @summary Trigger a respond call for a thread
 */
export const usersGenerateTwinResponse = (
    org: string,
    id: string,
    twinRespond: TwinRespond,
    params?: UsersGenerateTwinResponseParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderResult>> => {
    return axios.post(
      `/api/v1/orgs/${org}/user/twin-respond/${id}`,
      twinRespond,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type UsersGenerateTwinResponseMutationResult = NonNullable<Awaited<ReturnType<typeof usersGenerateTwinResponse>>>
    export type UsersGenerateTwinResponseMutationBody = TwinRespond
    export type UsersGenerateTwinResponseMutationError = AxiosError<void | Failure>

    export const useUsersGenerateTwinResponse = <TError = AxiosError<void | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersGenerateTwinResponse>>, TError,{org: string;id: string;data: TwinRespond;params?: UsersGenerateTwinResponseParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersGenerateTwinResponse>>, {org: string;id: string;data: TwinRespond;params?: UsersGenerateTwinResponseParams}> = (props) => {
          const {org,id,data,params} = props ?? {};

          return  usersGenerateTwinResponse(org,id,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersGenerateTwinResponse>>, TError, {org: string;id: string;data: TwinRespond;params?: UsersGenerateTwinResponseParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Update existing response with externally supplied content
 * @summary Update existing response with external content
 */
export const usersUpdateTwinResponse = (
    org: string,
    id: string,
    twinRespondUpdate: TwinRespondUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderResult>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/user/twin-respond/${id}`,
      twinRespondUpdate,options
    );
  }



    export type UsersUpdateTwinResponseMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateTwinResponse>>>
    export type UsersUpdateTwinResponseMutationBody = TwinRespondUpdate
    export type UsersUpdateTwinResponseMutationError = AxiosError<void | Failure>

    export const useUsersUpdateTwinResponse = <TError = AxiosError<void | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateTwinResponse>>, TError,{org: string;id: string;data: TwinRespondUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateTwinResponse>>, {org: string;id: string;data: TwinRespondUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  usersUpdateTwinResponse(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersUpdateTwinResponse>>, TError, {org: string;id: string;data: TwinRespondUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Trigger a respond call for a thread
 * @summary Delete an existing draft
 */
export const usersDeleteResponseDraft = (
    org: string,
    id: string,
    params: UsersDeleteResponseDraftParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/user/twin-respond/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type UsersDeleteResponseDraftMutationResult = NonNullable<Awaited<ReturnType<typeof usersDeleteResponseDraft>>>
    
    export type UsersDeleteResponseDraftMutationError = AxiosError<NotFoundResponse | Failure>

    export const useUsersDeleteResponseDraft = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersDeleteResponseDraft>>, TError,{org: string;id: string;params: UsersDeleteResponseDraftParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersDeleteResponseDraft>>, {org: string;id: string;params: UsersDeleteResponseDraftParams}> = (props) => {
          const {org,id,params} = props ?? {};

          return  usersDeleteResponseDraft(org,id,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersDeleteResponseDraft>>, TError, {org: string;id: string;params: UsersDeleteResponseDraftParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Trigger a respond call for a thread - but not save the content, if draft already exists - attempt to improve the response
 * @summary Trigger a respond call for a thread
 */
export const usersGenerateTwinResponseContent = (
    org: string,
    id: string,
    twinRespondImprove: TwinRespondImprove,
    params?: UsersGenerateTwinResponseContentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderContentResult>> => {
    return axios.post(
      `/api/v1/orgs/${org}/user/twin-improve/${id}`,
      twinRespondImprove,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type UsersGenerateTwinResponseContentMutationResult = NonNullable<Awaited<ReturnType<typeof usersGenerateTwinResponseContent>>>
    export type UsersGenerateTwinResponseContentMutationBody = TwinRespondImprove
    export type UsersGenerateTwinResponseContentMutationError = AxiosError<void | Failure>

    export const useUsersGenerateTwinResponseContent = <TError = AxiosError<void | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersGenerateTwinResponseContent>>, TError,{org: string;id: string;data: TwinRespondImprove;params?: UsersGenerateTwinResponseContentParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersGenerateTwinResponseContent>>, {org: string;id: string;data: TwinRespondImprove;params?: UsersGenerateTwinResponseContentParams}> = (props) => {
          const {org,id,data,params} = props ?? {};

          return  usersGenerateTwinResponseContent(org,id,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersGenerateTwinResponseContent>>, TError, {org: string;id: string;data: TwinRespondImprove;params?: UsersGenerateTwinResponseContentParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Trigger a respond call for a thread
 * @summary Construct an email
 */
export const usersConstructEmail = (
    org: string,
    twinConstructEmail: TwinConstructEmail,
    params?: UsersConstructEmailParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TwinResponderContentResult>> => {
    return axios.post(
      `/api/v1/orgs/${org}/user/twin-construct-email`,
      twinConstructEmail,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type UsersConstructEmailMutationResult = NonNullable<Awaited<ReturnType<typeof usersConstructEmail>>>
    export type UsersConstructEmailMutationBody = TwinConstructEmail
    export type UsersConstructEmailMutationError = AxiosError<void | Failure>

    export const useUsersConstructEmail = <TError = AxiosError<void | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersConstructEmail>>, TError,{org: string;data: TwinConstructEmail;params?: UsersConstructEmailParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersConstructEmail>>, {org: string;data: TwinConstructEmail;params?: UsersConstructEmailParams}> = (props) => {
          const {org,data,params} = props ?? {};

          return  usersConstructEmail(org,data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersConstructEmail>>, TError, {org: string;data: TwinConstructEmail;params?: UsersConstructEmailParams}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Trigger a respond call for a thread
 * @summary Update an email draft
 */
export const usersConstructEmailUpdate = (
    org: string,
    twinConstructEmailUpdate: TwinConstructEmailUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.put(
      `/api/v1/orgs/${org}/user/twin-construct-email`,
      twinConstructEmailUpdate,options
    );
  }



    export type UsersConstructEmailUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersConstructEmailUpdate>>>
    export type UsersConstructEmailUpdateMutationBody = TwinConstructEmailUpdate
    export type UsersConstructEmailUpdateMutationError = AxiosError<Failure>

    export const useUsersConstructEmailUpdate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersConstructEmailUpdate>>, TError,{org: string;data: TwinConstructEmailUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersConstructEmailUpdate>>, {org: string;data: TwinConstructEmailUpdate}> = (props) => {
          const {org,data} = props ?? {};

          return  usersConstructEmailUpdate(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersConstructEmailUpdate>>, TError, {org: string;data: TwinConstructEmailUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get authenticated user

 * @summary Get the authenticated user
 */
export const usersGetAuthenticated = (
    params?: UsersGetAuthenticatedParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UsersGetAuthenticated200>> => {
    return axios.get(
      `/api/v1/user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUsersGetAuthenticatedQueryKey = (params?: UsersGetAuthenticatedParams,) => [`/api/v1/user`, ...(params ? [params]: [])];

    
export type UsersGetAuthenticatedQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetAuthenticated>>>
export type UsersGetAuthenticatedQueryError = AxiosError<unknown>

export const useUsersGetAuthenticated = <TData = Awaited<ReturnType<typeof usersGetAuthenticated>>, TError = AxiosError<unknown>>(
 params?: UsersGetAuthenticatedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetAuthenticated>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetAuthenticatedQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetAuthenticated>>> = ({ signal }) => usersGetAuthenticated(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetAuthenticated>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update the authenticated user
 * @summary Update the authenticated user
 */
export const usersUpdateAuthenticated = (
    userUpdate: UserUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<User>> => {
    return axios.patch(
      `/api/v1/user`,
      userUpdate,options
    );
  }



    export type UsersUpdateAuthenticatedMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateAuthenticated>>>
    export type UsersUpdateAuthenticatedMutationBody = UserUpdate
    export type UsersUpdateAuthenticatedMutationError = AxiosError<unknown>

    export const useUsersUpdateAuthenticated = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateAuthenticated>>, TError,{data: UserUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateAuthenticated>>, {data: UserUpdate}> = (props) => {
          const {data} = props ?? {};

          return  usersUpdateAuthenticated(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersUpdateAuthenticated>>, TError, {data: UserUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete the user from the organizaton; if the user is the last owner of the organization, the organization will be deleted as well
 * @summary delete the user from the organization
 */
export const usersDeleteAuthenticated = (
    userFeedback: UserFeedback, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull[]>> => {
    return axios.delete(
      `/api/v1/user`,{data:
      userFeedback, ...options}
    );
  }



    export type UsersDeleteAuthenticatedMutationResult = NonNullable<Awaited<ReturnType<typeof usersDeleteAuthenticated>>>
    export type UsersDeleteAuthenticatedMutationBody = UserFeedback
    export type UsersDeleteAuthenticatedMutationError = AxiosError<Failure>

    export const useUsersDeleteAuthenticated = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersDeleteAuthenticated>>, TError,{data: UserFeedback}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersDeleteAuthenticated>>, {data: UserFeedback}> = (props) => {
          const {data} = props ?? {};

          return  usersDeleteAuthenticated(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersDeleteAuthenticated>>, TError, {data: UserFeedback}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * enable features for a user
 * @summary enable features for a user
 */
export const usersEnableFeatures = (
    feature: Feature, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(
      `/api/v1/user/features`,
      feature,options
    );
  }



    export type UsersEnableFeaturesMutationResult = NonNullable<Awaited<ReturnType<typeof usersEnableFeatures>>>
    export type UsersEnableFeaturesMutationBody = Feature
    export type UsersEnableFeaturesMutationError = AxiosError<Failure>

    export const useUsersEnableFeatures = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersEnableFeatures>>, TError,{data: Feature}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersEnableFeatures>>, {data: Feature}> = (props) => {
          const {data} = props ?? {};

          return  usersEnableFeatures(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersEnableFeatures>>, TError, {data: Feature}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List organizations for the authenticated user.

**OAuth scope requirements**

This only lists organizations that your authorization allows you to operate on in some way
(e.g., you can list teams with `read:org` scope, you can publicize your organization membership with `user` scope, etc.).
Therefore, this API requires at least `user` or `read:org` scope. OAuth requests with insufficient scope receive a `403 Forbidden` response.
 * @summary List organizations for the authenticated user
 */
export const orgsListForAuthenticatedUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull[]>> => {
    return axios.get(
      `/api/v1/user/orgs`,options
    );
  }


export const getOrgsListForAuthenticatedUserQueryKey = () => [`/api/v1/user/orgs`];

    
export type OrgsListForAuthenticatedUserQueryResult = NonNullable<Awaited<ReturnType<typeof orgsListForAuthenticatedUser>>>
export type OrgsListForAuthenticatedUserQueryError = AxiosError<unknown>

export const useOrgsListForAuthenticatedUser = <TData = Awaited<ReturnType<typeof orgsListForAuthenticatedUser>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof orgsListForAuthenticatedUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrgsListForAuthenticatedUserQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orgsListForAuthenticatedUser>>> = ({ signal }) => orgsListForAuthenticatedUser({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof orgsListForAuthenticatedUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create an organization for the authenticated user.
 * @summary create an organization for the authenticated user
 */
export const orgsCreateForAuthenticatedUser = (
    organizationNew: OrganizationNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull>> => {
    return axios.post(
      `/api/v1/user/orgs`,
      organizationNew,options
    );
  }



    export type OrgsCreateForAuthenticatedUserMutationResult = NonNullable<Awaited<ReturnType<typeof orgsCreateForAuthenticatedUser>>>
    export type OrgsCreateForAuthenticatedUserMutationBody = OrganizationNew
    export type OrgsCreateForAuthenticatedUserMutationError = AxiosError<Failure>

    export const useOrgsCreateForAuthenticatedUser = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof orgsCreateForAuthenticatedUser>>, TError,{data: OrganizationNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof orgsCreateForAuthenticatedUser>>, {data: OrganizationNew}> = (props) => {
          const {data} = props ?? {};

          return  orgsCreateForAuthenticatedUser(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof orgsCreateForAuthenticatedUser>>, TError, {data: OrganizationNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * change password for user
 * @summary change password for user
 */
export const usersChangePassword = (
    userChangePassword: UserChangePassword, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/user/password`,
      userChangePassword,options
    );
  }



    export type UsersChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof usersChangePassword>>>
    export type UsersChangePasswordMutationBody = UserChangePassword
    export type UsersChangePasswordMutationError = AxiosError<NotFoundResponse | Failure>

    export const useUsersChangePassword = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersChangePassword>>, TError,{data: UserChangePassword}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersChangePassword>>, {data: UserChangePassword}> = (props) => {
          const {data} = props ?? {};

          return  usersChangePassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersChangePassword>>, TError, {data: UserChangePassword}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * check if user has permission to provided function
 * @summary check if user has permission to provided function
 */
export const usersCheckPermission = (
    params: UsersCheckPermissionParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserPermission>> => {
    return axios.get(
      `/api/v1/user/permission`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUsersCheckPermissionQueryKey = (params: UsersCheckPermissionParams,) => [`/api/v1/user/permission`, ...(params ? [params]: [])];

    
export type UsersCheckPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof usersCheckPermission>>>
export type UsersCheckPermissionQueryError = AxiosError<NotFoundResponse | Failure>

export const useUsersCheckPermission = <TData = Awaited<ReturnType<typeof usersCheckPermission>>, TError = AxiosError<NotFoundResponse | Failure>>(
 params: UsersCheckPermissionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersCheckPermission>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersCheckPermissionQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersCheckPermission>>> = ({ signal }) => usersCheckPermission(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersCheckPermission>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Get primary organization for the authenticated user.
 * @summary Get primary organization for the authenticated user
 */
export const orgsGetPrimaryForAuthenticatedUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OrganizationFull>> => {
    return axios.get(
      `/api/v1/user/orgs/primary`,options
    );
  }


export const getOrgsGetPrimaryForAuthenticatedUserQueryKey = () => [`/api/v1/user/orgs/primary`];

    
export type OrgsGetPrimaryForAuthenticatedUserQueryResult = NonNullable<Awaited<ReturnType<typeof orgsGetPrimaryForAuthenticatedUser>>>
export type OrgsGetPrimaryForAuthenticatedUserQueryError = AxiosError<unknown>

export const useOrgsGetPrimaryForAuthenticatedUser = <TData = Awaited<ReturnType<typeof orgsGetPrimaryForAuthenticatedUser>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof orgsGetPrimaryForAuthenticatedUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrgsGetPrimaryForAuthenticatedUserQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof orgsGetPrimaryForAuthenticatedUser>>> = ({ signal }) => orgsGetPrimaryForAuthenticatedUser({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof orgsGetPrimaryForAuthenticatedUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * upload a photo for the users
 * @summary upload a photo for the user
 */
export const usersUploadPicture = (
    usersUploadPictureBody: Blob, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Picture>> => {
    return axios.post(
      `/api/v1/user/picture`,
      usersUploadPictureBody,options
    );
  }



    export type UsersUploadPictureMutationResult = NonNullable<Awaited<ReturnType<typeof usersUploadPicture>>>
    export type UsersUploadPictureMutationBody = Blob
    export type UsersUploadPictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useUsersUploadPicture = <TError = AxiosError<NotFoundResponse | Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUploadPicture>>, TError,{data: Blob}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUploadPicture>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  usersUploadPicture(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersUploadPicture>>, TError, {data: Blob}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * delete a picture for the users
 * @summary delete users picture
 */
export const usersDeletePicture = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/user/picture`,options
    );
  }



    export type UsersDeletePictureMutationResult = NonNullable<Awaited<ReturnType<typeof usersDeletePicture>>>
    
    export type UsersDeletePictureMutationError = AxiosError<NotFoundResponse | Failure>

    export const useUsersDeletePicture = <TError = AxiosError<NotFoundResponse | Failure>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersDeletePicture>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersDeletePicture>>, TVariables> = () => {
          

          return  usersDeletePicture(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersDeletePicture>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Get refreshed JWT token for user
 * @summary Get refreshed JWT token for user
 */
export const usersGetToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.get(
      `/api/v1/user/token`,options
    );
  }


export const getUsersGetTokenQueryKey = () => [`/api/v1/user/token`];

    
export type UsersGetTokenQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetToken>>>
export type UsersGetTokenQueryError = AxiosError<unknown>

export const useUsersGetToken = <TData = Awaited<ReturnType<typeof usersGetToken>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetToken>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetTokenQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetToken>>> = ({ signal }) => usersGetToken({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof usersGetToken>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Returns a list of current products
 * @summary Returns a list of current products
 */
export const productsList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Product[]>> => {
    return axios.get(
      `/api/v1/products`,options
    );
  }


export const getProductsListQueryKey = () => [`/api/v1/products`];

    
export type ProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof productsList>>>
export type ProductsListQueryError = AxiosError<Failure>

export const useProductsList = <TData = Awaited<ReturnType<typeof productsList>>, TError = AxiosError<Failure>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof productsList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProductsListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof productsList>>> = ({ signal }) => productsList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof productsList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * List notifications for the user
 * @summary List notifications for the user
 */
export const notificationsList = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Notification[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/notifications`,options
    );
  }


export const getNotificationsListQueryKey = (org: string,) => [`/api/v1/orgs/${org}/notifications`];

    
export type NotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsList>>>
export type NotificationsListQueryError = AxiosError<unknown>

export const useNotificationsList = <TData = Awaited<ReturnType<typeof notificationsList>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationsList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsListQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsList>>> = ({ signal }) => notificationsList(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof notificationsList>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update a notification status
 * @summary Update a notification
 */
export const notificationsMarkRead = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/notifications/${id}`,undefined,options
    );
  }



    export type NotificationsMarkReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsMarkRead>>>
    
    export type NotificationsMarkReadMutationError = AxiosError<unknown>

    export const useNotificationsMarkRead = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkRead>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsMarkRead>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  notificationsMarkRead(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof notificationsMarkRead>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Mark all notification as read
 * @summary Mark all notification as read
 */
export const notificationsMarkAllRead = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/notifications-status`,undefined,options
    );
  }



    export type NotificationsMarkAllReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsMarkAllRead>>>
    
    export type NotificationsMarkAllReadMutationError = AxiosError<unknown>

    export const useNotificationsMarkAllRead = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsMarkAllRead>>, TError,{org: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsMarkAllRead>>, {org: string}> = (props) => {
          const {org} = props ?? {};

          return  notificationsMarkAllRead(org,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof notificationsMarkAllRead>>, TError, {org: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * return unread notification count for the user
 * @summary return unread notification count for the user
 */
export const notificationsGetUnreadCount = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationsGetUnreadCount200>> => {
    return axios.get(
      `/api/v1/orgs/${org}/notifications-unread`,options
    );
  }


export const getNotificationsGetUnreadCountQueryKey = (org: string,) => [`/api/v1/orgs/${org}/notifications-unread`];

    
export type NotificationsGetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsGetUnreadCount>>>
export type NotificationsGetUnreadCountQueryError = AxiosError<unknown>

export const useNotificationsGetUnreadCount = <TData = Awaited<ReturnType<typeof notificationsGetUnreadCount>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationsGetUnreadCount>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsGetUnreadCountQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsGetUnreadCount>>> = ({ signal }) => notificationsGetUnreadCount(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof notificationsGetUnreadCount>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * List notification subscriptions for the user
 * @summary List notification subscriptions for the user
 */
export const notificationsListSubscriptions = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSubscription[]>> => {
    return axios.get(
      `/api/v1/orgs/${org}/notification-subscriptions`,options
    );
  }


export const getNotificationsListSubscriptionsQueryKey = (org: string,) => [`/api/v1/orgs/${org}/notification-subscriptions`];

    
export type NotificationsListSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsListSubscriptions>>>
export type NotificationsListSubscriptionsQueryError = AxiosError<unknown>

export const useNotificationsListSubscriptions = <TData = Awaited<ReturnType<typeof notificationsListSubscriptions>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationsListSubscriptions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsListSubscriptionsQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsListSubscriptions>>> = ({ signal }) => notificationsListSubscriptions(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof notificationsListSubscriptions>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update notification setting by name
 * @summary Update notification setting by name
 */
export const notificationsUpdateSubscriptions = (
    org: string,
    notificationSubscription: NotificationSubscription[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/v1/orgs/${org}/notification-subscriptions`,
      notificationSubscription,options
    );
  }



    export type NotificationsUpdateSubscriptionsMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsUpdateSubscriptions>>>
    export type NotificationsUpdateSubscriptionsMutationBody = NotificationSubscription[]
    export type NotificationsUpdateSubscriptionsMutationError = AxiosError<unknown>

    export const useNotificationsUpdateSubscriptions = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsUpdateSubscriptions>>, TError,{org: string;data: NotificationSubscription[]}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsUpdateSubscriptions>>, {org: string;data: NotificationSubscription[]}> = (props) => {
          const {org,data} = props ?? {};

          return  notificationsUpdateSubscriptions(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof notificationsUpdateSubscriptions>>, TError, {org: string;data: NotificationSubscription[]}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * List notification settings by the subscription id
 * @summary List notification settings by the subscription id
 */
export const notificationsListSettings = (
    org: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationSettings>> => {
    return axios.get(
      `/api/v1/orgs/${org}/notification-settings`,options
    );
  }


export const getNotificationsListSettingsQueryKey = (org: string,) => [`/api/v1/orgs/${org}/notification-settings`];

    
export type NotificationsListSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsListSettings>>>
export type NotificationsListSettingsQueryError = AxiosError<unknown>

export const useNotificationsListSettings = <TData = Awaited<ReturnType<typeof notificationsListSettings>>, TError = AxiosError<unknown>>(
 org: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationsListSettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsListSettingsQueryKey(org);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsListSettings>>> = ({ signal }) => notificationsListSettings(org, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof notificationsListSettings>>, TError, TData>(queryKey, queryFn, {enabled: !!(org), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * create a comment
 * @summary create a comment
 */
export const commentsCreate = (
    org: string,
    commentNew: CommentNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Comment>> => {
    return axios.post(
      `/api/v1/orgs/${org}/comments`,
      commentNew,options
    );
  }



    export type CommentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof commentsCreate>>>
    export type CommentsCreateMutationBody = CommentNew
    export type CommentsCreateMutationError = AxiosError<Failure>

    export const useCommentsCreate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commentsCreate>>, TError,{org: string;data: CommentNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commentsCreate>>, {org: string;data: CommentNew}> = (props) => {
          const {org,data} = props ?? {};

          return  commentsCreate(org,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof commentsCreate>>, TError, {org: string;data: CommentNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a comment by id
 * @summary Returns a comment by Id
 */
export const commentsGet = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Comment | void>> => {
    return axios.get(
      `/api/v1/orgs/${org}/comments/${id}`,options
    );
  }


export const getCommentsGetQueryKey = (org: string,
    id: string,) => [`/api/v1/orgs/${org}/comments/${id}`];

    
export type CommentsGetQueryResult = NonNullable<Awaited<ReturnType<typeof commentsGet>>>
export type CommentsGetQueryError = AxiosError<Failure>

export const useCommentsGet = <TData = Awaited<ReturnType<typeof commentsGet>>, TError = AxiosError<Failure>>(
 org: string,
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof commentsGet>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCommentsGetQueryKey(org,id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof commentsGet>>> = ({ signal }) => commentsGet(org,id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof commentsGet>>, TError, TData>(queryKey, queryFn, {enabled: !!(org && id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Update a comment or a comment thread if it's a root comment
 * @summary Update a comment or status on a comment thread if it's a root comment
 */
export const commentsUpdate = (
    org: string,
    id: string,
    commentUpdate: CommentUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.patch(
      `/api/v1/orgs/${org}/comments/${id}`,
      commentUpdate,options
    );
  }



    export type CommentsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof commentsUpdate>>>
    export type CommentsUpdateMutationBody = CommentUpdate
    export type CommentsUpdateMutationError = AxiosError<Failure>

    export const useCommentsUpdate = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commentsUpdate>>, TError,{org: string;id: string;data: CommentUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commentsUpdate>>, {org: string;id: string;data: CommentUpdate}> = (props) => {
          const {org,id,data} = props ?? {};

          return  commentsUpdate(org,id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof commentsUpdate>>, TError, {org: string;id: string;data: CommentUpdate}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * deletes a comment by Id
 * @summary deletes comment or thread by Id
 */
export const commentsDelete = (
    org: string,
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/api/v1/orgs/${org}/comments/${id}`,options
    );
  }



    export type CommentsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof commentsDelete>>>
    
    export type CommentsDeleteMutationError = AxiosError<Failure>

    export const useCommentsDelete = <TError = AxiosError<Failure>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commentsDelete>>, TError,{org: string;id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commentsDelete>>, {org: string;id: string}> = (props) => {
          const {org,id} = props ?? {};

          return  commentsDelete(org,id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof commentsDelete>>, TError, {org: string;id: string}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * run prediction against llm models
 */
export const aiLlmPredict = (
    aiLlmPredictBody: unknown, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Prediction>> => {
    return axios.post(
      `/api/v1/ai/llm/predict`,
      aiLlmPredictBody,options
    );
  }



    export type AiLlmPredictMutationResult = NonNullable<Awaited<ReturnType<typeof aiLlmPredict>>>
    export type AiLlmPredictMutationBody = unknown
    export type AiLlmPredictMutationError = AxiosError<unknown>

    export const useAiLlmPredict = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aiLlmPredict>>, TError,{data: unknown}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aiLlmPredict>>, {data: unknown}> = (props) => {
          const {data} = props ?? {};

          return  aiLlmPredict(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof aiLlmPredict>>, TError, {data: unknown}, TContext>(mutationFn, mutationOptions)
    }
    
